// PersonalizationSections.tsx · v12.10.28 (#2209 Edit entry: Connected systems moved to Integrations › Translations) · 2026-11-02 · VoiceSpectrum AI
// PersonalizationSections.tsx · v12.10.26 (#2141 Vocabulary › Lists: the Locations list is read-only, filled from Organization › Locations) · 2026-10-30 · VoiceSpectrum AI
// PersonalizationSections.tsx · v12.10.26 (#2128 Repeat callers: No further details - the editable short-reply list) · 2026-10-30 · VoiceSpectrum AI
// PersonalizationSections.tsx · v12.10.25 (#2104 Messages refresh default 60 s) · 2026-10-30 · VoiceSpectrum AI
// PersonalizationSections.tsx · v12.10.23 (#2068 Repeat callers: where each answer goes - one line per answer with a card picker; Yes + details closing line; Message received default without "Our staff will get back to you") · 2026-10-29 · VoiceSpectrum AI
// PersonalizationSections.tsx · v12.10.22 (#2011 Categories: Used by; #2003 the save toast names the section that was saved - Messages workspace, Repeat callers or both) · 2026-10-28 · VoiceSpectrum AI
// PersonalizationSections.tsx · v12.10.19 (#1898 the Repeat callers lines use the shared prompt editor - Play, translate, Reset, Insert token, the template as real text; #1924 #1925 What the caller needs settings) · 2026-10-23 · VoiceSpectrum AI
// PersonalizationSections.tsx · v12.10.18 (#1864 Messages workspace + Repeat callers as two sections; #1863 Continue where left off, Mode · Classic, the lines per language) · 2026-10-22 · VoiceSpectrum AI
// PersonalizationSections.tsx · v12.10.17 (#1723 T120 follow-up: dead "Files under" import removed - retired per Tushar 10/16) · 2026-10-16 · VoiceSpectrum AI
// PersonalizationSections.tsx · v12.10.17 (#1723 T120 / BDR-018: Caller types + Categories come from the workflow (D10), edit COLOUR + ICON only - no Name / Key / Active / Add / Delete, "Edit Caller Type (Workflow)" / "Edit Category (Workflow)" (D11); system Unclassified in both, slate never offered (D2); icon set v1.5 in the caller-type picker (D14)) · 2026-10-16 · VoiceSpectrum AI
// PersonalizationSections.tsx · v12.10.17 (#1758 Repeat callers / Automatic status each dirty for their own keys; #1728 NumberField checks on blur, no per-keystroke clamp) · 2026-10-16 · VoiceSpectrum AI
// PersonalizationSections.tsx · v12.10.16.1 (#1702 Refresh the Messages list every N seconds) · 2026-10-14 · VoiceSpectrum AI
// PersonalizationSections.tsx · v12.10.16 (T113 Repeat callers + Automatic status) · 2026-10-14 · VoiceSpectrum AI
// PersonalizationSections.tsx · v12.10.11.1 (#1486 Edit category shows "Used by: <intents>" read-only with a link to each workflow card) · 2026-10-09
// PersonalizationSections.tsx · v12.10.10.1 (#1421 "Save your changes first?" styled buttons, names the section "Fields"; #1419 Edit list chip shows the column, Remove list is danger) · 2026-10-08 · VoiceSpectrum AI
// PersonalizationSections.tsx · v12.10.10 (#1406 Lists: New / Edit list drawer - name, status, what it is for, offer up to, tied to, internal id; entry drawer - Name + Status, Description, Custom 1 / 2, language rail on Caller might say + AI says back (auto-translated, editable), connected-system rows; any field tied to a list + column; C4 / C5 / C8. #1407 a drawer saves on its own Save; opening one with unsaved page edits asks to save them first) · 2026-10-08 · VoiceSpectrum AI
// v1.x · v12.10.8.1 (#1229 a practice's own fields = teal "Custom:" chip line; #1230 "+ Add new vocabulary" / "+ Add new list"
//   at the top, Edit · Delete next to a custom term, Import… small secondary; #1233 "+ Add new vocabulary" creates a term
//   (Term, Your label, What it is); Term column = a locked box the size of Your label) · 2026-10-05
// v1.x · v12.10.8 (#1160 Vocabulary leaves Personalization - part="vocabulary" renders Fields + Lists, part="personalization"
//   the other four; #1227 On / Off on every field and list - Off hides it from display only; #1190 a tenant field's Input
//   cleanup is saved; Identity extraction is gone) · 2026-10-05
// v12.9.27 (#1045): the Field drawer saves a Date / Time field's rules (dateRule) - to field-overrides for a platform
//   field, to custom-fields for the tenant's own; the drawer gets the offer per purpose and the read-only date order.
// v12.9.26 (#969): the Agent phrases section is retired here - Workflow > Phrases owns the same stored values.
// v12.7.2 (#614): a tenant's own entity row reads "Custom \u2014 {label}" and carries the same hyperlinked
//   field chips the platform rows have. Reported six times, never logged until today.
// v12.6.2 (#576): every field on a vocabulary entity OPENS and shows its TYPE - the thing the call engine
//   validates a live answer against (#563) and, since #569, the thing that decides whether a caller is
//   re-asked at all. Platform fields were flat text while the tenant's own fields were clickable.
// PersonalizationSections.tsx — v12.4.16 (#499 Vocabulary is tenant-extensible: "Add field" on any entity,
//   rendered by the SAME drawer Identity extraction opens; the tenant's own fields on a PLATFORM entity are
//   finally visible. #500 the Lists section.)
// v12.2.43.2 (#236): plainer Vocabulary wording (intro + tooltip + role descriptions)
// PersonalizationSections.tsx — v12.3.12.5 (#334 an expired session says so instead of "try again"; #335 custom vocabulary entities read back)
// Settings › Personalization (4 independent sections): Caller types · Categories · Labels · Message
// grouping. Loads via GET /t2/surface/personalization; each section Saves LIVE to its own REAL tenant
// table via a per-section PUT (/t2/surface/personalization/caller-types · /categories · /labels ·
// /settings — the last carries overrides+grouping, the single personalization_settings row). State/save
// mechanics mirror CallHandlingSections (useQuery load, structuredClone draft/saved, per-section
// useMutation + onStateChange dirty reporting). Ported for fidelity from personalization_only_v1_62.html.
//
// Notes:
//  • Locked system rows Unclassified / Uncategorized are DISPLAY-ONLY — never in the data arrays.
//  • Lists DISPLAY alphabetically by name but preserve true array indices for edit/delete (sort a view).
//  • caller-type / category KEYS are what workflow steps emit into (real binding, not a display layer).
//  • Category icons use a fixed CAT_ICONS name list (no shared SvgIcon set exists in T2 yet).
//  • grouping.appendWindow is shown only when sameCaller==='continue'.
//  • v12.2.42.0 (#236): Vocabulary section (moved here from Organization). Loads its entity->label map from a
//    SEPARATE source — GET /t2/settings/organization (.vocabulary) — and saves via PUT .../organization/vocabulary.
import { ReactNode, useEffect, useMemo, useRef, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api';
// v12.10.17 (#1723 T120 follow-up): intentsFilingUnder (#1486 "Files under") no longer imported - retired per Tushar 10/16.
import { Link } from 'react-router-dom';   // v12.10.11.1 (#1486): "Open card ->" goes through the app's own navigation (unsaved-changes guard)
import { saveErrorToast } from '../lib/saveError';   // v12.3.12.5 (#334)
// v12.3.11 (#305): every save on this page now confirms itself with the canonical bottom-centre toast.
// Reported from the 12.3.10 pass: renaming Vocabulary and pressing Save all changes said nothing at all.
import { toast } from '../lib/toast';
import { ConfirmDelete } from '../components/ConfirmDelete';   // v12.3.12 (#323)
import { HelpTooltip, HelpSection } from '../components/aiagent/HelpTooltip';
import { PromptEditor, platformGroups } from '../components/PromptEditor';   // v12.10.19 (#1898)
import { RESOLVER_KNOWN_TOKENS } from '../lib/tokenPreview';   // v12.10.19 (#1898): the repeat-caller lines' token picker
import './settings-controls.css';
import './call-handling.css';
import './personalization.css';
import { CallerTypeIcon, CALLER_ICON_GROUPS, iconLabel, PracticeIcon } from '../components/CallerTypeIcon';   // v12.2.43.0 (#244) · v12.10.17 (#1723 D14)
// v12.4.16 (#499): the SAME drawer Settings › AI Agent › Identity extraction opens. Tushar: "we can call the
// same drawer from identity to here." Two entry points, one component - see VocabularyFieldDrawer's header.
import { VocabularyFieldDrawer, type VocabFieldDraft } from '../components/vocabulary/VocabularyFieldDrawer';
import type { DateRule, DatePurposeInfo, DateOrderInfo } from '../components/vocabulary/DateRulesBox';

export interface CallerType { name: string; key: string; color: string; icon: string; active: boolean; aliases?: string[] }   // v12.2.43.0 (#244): + icon · v12.10.17 (#1723 D12): + aliases (read only)
export interface Category { name: string; key: string; color: string; icon: string; active: boolean; aliases?: string[]; usedBy?: string[]; usedByKeys?: string[] }   // v12.10.22 (#2011): + usedBy (read only)
export interface Label { name: string; description: string; color: string }
export interface Overrides { callerType: boolean; category: boolean }
export interface Grouping {
  sameCaller: 'continue' | 'new'; appendWindow: number;
  // v12.10.16 (T113 #1689 #1690 #1691, UI-PROTO-REPEAT-CALLER-GROUPING-B1 v1.10 LOCKED): Repeat callers + Automatic status.
  // Saved with the grouping (one Save); stored in tenant_settings["repeatCallers"].
  onCall?: 'off' | 'greeting' | 'voicemail'; onCallWindow?: number; sameDay?: boolean; autoComplete?: boolean;
  refreshSeconds?: number;   // v12.10.16.1 (#1702): how often an open Messages list refreshes
  // v12.10.18 (#1863 T148, UI-PROTO-T148 v1.10 LOCKED 10/22): Mode · Classic + the practice's own lines (key -> lang -> text).
  classic?: boolean;
  lines?: Record<string, Record<string, string>>;
  // v12.10.19 (#1924 #1925, LOCKED 10/23): What the caller needs - Live calls / Voicemails / As spoken words / confirmation threshold
  needsLive?: 'local' | 'ai'; needsVoicemail?: 'ai' | 'spoken' | 'local'; needsSpokenWords?: number; confirmRequiredAt?: number;
  // v12.10.23 (#2068, UI-PROTO-T178 v1.4 LOCKED): where each answer goes - line -> answer -> destination; missing = the default.
  routes?: Record<string, Record<string, string>>;
  // v12.10.26 (#2128): the short replies that carry no further details (lang -> phrases) - never reopen a completed message.
  noDetailsReplies?: Record<string, string[]>;
}
/** v12.10.16: GET /personalization returns repeatCallers beside grouping - the screen keeps them with the grouping. */
interface RepeatCallersDto { onCall?: 'off' | 'greeting' | 'voicemail'; onCallWindow?: number; sameDay?: boolean; autoCompleteEmptyMissed?: boolean; refreshSeconds?: number;
  classic?: boolean; lines?: Record<string, Record<string, string>> | null;   // v12.10.18 (#1863)
  needsLive?: 'local' | 'ai'; needsVoicemail?: 'ai' | 'spoken' | 'local'; needsSpokenWords?: number; confirmRequiredAt?: number;   // v12.10.19 (#1924 #1925)
  routes?: Record<string, Record<string, string>> | null;   // v12.10.23 (#2068)
  noDetailsReplies?: Record<string, string[]> | null }   // v12.10.26 (#2128)
function withRepeat(d: PersonalizationData & { repeatCallers?: RepeatCallersDto }): PersonalizationData {
  const r = d.repeatCallers ?? {};
  return { ...d, grouping: { ...d.grouping, onCall: r.onCall ?? 'off', onCallWindow: r.onCallWindow ?? 10, sameDay: r.sameDay ?? false, autoComplete: r.autoCompleteEmptyMissed ?? false, refreshSeconds: r.refreshSeconds ?? 60,
    classic: r.classic ?? false, lines: r.lines ?? {},   // v12.10.18 (#1863)
    routes: r.routes ?? {},   // v12.10.23 (#2068)
    noDetailsReplies: r.noDetailsReplies ?? {},   // v12.10.26 (#2128)
    needsLive: r.needsLive ?? 'local', needsVoicemail: r.needsVoicemail ?? 'local', needsSpokenWords: r.needsSpokenWords ?? 25, confirmRequiredAt: r.confirmRequiredAt ?? 3 } };   // v12.10.19
}

export interface PersonalizationData {
  callerTypes: CallerType[];
  categories: Category[];
  labels: Label[];
  overrides: Overrides;
  grouping: Grouping;
}

// Internal section keys are STABLE (dirty-tracking + nav depend on them). "categories" carries the
// visible label "Categories" but the prototype's internal name is "Message categories".
// v12.4.16 (#500): a LIST - the legal values a vocabulary field may hold, and what each one is called in
// every other system. See ReferenceListDto in OrganizationSettingsController for why each part is here.
export interface ListEntry {
  id: string;                               // stable, never reused - historical calls point at it
  name: string;
  description: string;
  aliases: string[];                        // for MATCHING what the caller said
  spoken: string;                           // for READING IT BACK
  active: boolean;                          // deactivate, never delete
  externalIds: Record<string, string>;      // keyed BY INTEGRATION, never one column
  // v12.10.10 (#1406)
  custom1?: string;
  custom2?: string;
  aliasesByLang?: Record<string, string[]>;
  spokenByLang?: Record<string, string>;
  systems?: EntrySystem[];
}
/** v12.10.10 (#1406 D1): what one connected system gets - typed value or a column, and its id. */
export interface EntrySystem { system: string; valueFrom: 'typed' | 'name' | 'description' | 'custom1' | 'custom2'; value: string; theirId: string }
export interface RefList { key: string; name: string; description: string; entries: ListEntry[]; isOn?: boolean; defaultId?: string; offerCap?: number | null }   // v12.10.8 (#1227); v12.10.10 (#1406) offerCap

export type PzSectionKey = 'callerTypes' | 'categories' | 'labels' | 'grouping' | 'autoStatus' | 'vocabulary' | 'agentPhrases' | 'lists';   // v12.10.17 (#1758): autoStatus = the Automatic status card
export type PzDirtyMap = Record<PzSectionKey, boolean>;
export interface PersonalizationState { dirty: PzDirtyMap; anyDirty: boolean; saveAll: () => void; discardAll: () => void; }

const QKEY = ['t2-personalization'];

/** v12.10.16 (T113): the on/off switch of the Repeat callers / Automatic status cards (the prototype's switch, not a checkbox). */
function RcSwitch({ on, onChange, label, disabled }: { on: boolean; onChange: (v: boolean) => void; label: string; disabled?: boolean }) {
  return (
    <button type="button" role="switch" aria-checked={on} aria-label={label} disabled={disabled}
      className={`rc-sw${on ? ' on' : ''}`} onClick={() => onChange(!on)}><span className="rc-sw-thumb" aria-hidden="true" /></button>
  );
}

// 18-swatch palette — TENANT DATA color (not a theme token). Ported from the prototype PAL.
// v12.10.17 (#1723 D2): slate #64748B is the system Unclassified colour - never offered to a tenant (17 swatches).
const PAL = ['#E24B4A', '#F0674C', '#D85A30', '#F59E0B', '#EAB308', '#84CC16', '#10B981', '#5DCAA5', '#14B8A6', '#06B6D4', '#3B82F6', '#378ADD', '#6366F1', '#8B5CF6', '#A855F7', '#D4537E', '#EC4899'];
const UNCLASSIFIED_SLATE = '#64748B';
// Category icon NAMES (placeholder set — no shared SvgIcon registry in T2 yet; workspace renders the chip).
const CAT_ICONS = ['Help', 'Pill', 'Calendar', 'CalendarClock', 'Building2', 'Stethoscope', 'Phone', 'MessageCircle', 'FileText', 'CreditCard', 'MapPin', 'Activity', 'UserPlus', 'ClipboardList'];

function keyify(s: string) { return s.toLowerCase().trim().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, ''); }

// v12.2.42.0 (#236): Vocabulary entities. The token key NEVER changes (workflows bind to it); the tenant
// renames only the display label, which then shows in the token picker, the AI's spoken read-backs and
// call summaries. Saved as an entity->label JSON map in tenant_settings["vocabulary"] via the Organization
// settings controller (the CallEngine reads the same key at runtime). Fields column is informational only.
// v12.6.2 (#576): `fieldList` carries the STRUCTURED fields - key, label and TYPE - instead of the
// display string alone. The API has always sent the type (`vocabularyCatalog[].fields[].type`); this
// page threw it away one line after receiving it, which is why a platform field's type was invisible.
interface VocabField { key: string; label?: string; type?: string; source?: string; datePurpose?: string }
// fieldList is OPTIONAL so the built-in fallback list below stays a one-line literal per entity; the
// renderer derives chips from the display string when the fetch has not landed yet.
interface VocabEntity { token: string; what: string; sub: string; fields: string; fieldList?: VocabField[]; fallback: string }
const VOCAB_ENTITIES: VocabEntity[] = [
  { token: 'caller',   what: 'Who called',        sub: 'The person on the phone',                                                              fields: 'firstName · lastName · name · phone · dob · address1/2 · city · state · zip · county · country', fallback: 'Caller' },
  { token: 'subject',  what: "Who it's for",      sub: 'Who the call is about, often the caller but sometimes their child or someone they care for', fields: 'firstName · lastName · name · dob · address1/2 · city · state · zip · county · country',          fallback: 'Patient' },
  { token: 'request',  what: 'What they asked for', sub: 'The appointment / request details',                                                    fields: 'date · time · place · provider · reason',                                                       fallback: 'Appointment' },
  { token: 'provider', what: 'Who they\'ll see',    sub: 'The doctor, agent, or staff member',                                                     fields: 'name · role · location',                                                                       fallback: 'Doctor' },
  { token: 'location', what: 'Where it happens',   sub: 'The office / branch / site (for multi-location businesses)',                            fields: 'name · address1/2 · city · state · zip · phone',                                                fallback: 'Office' },
];

// v12.2.44.0 (#254): tenant-editable agent phrases. Each key maps to a spoken line the AI falls back to
// (silence re-asks, "anything else?", goodbyes, etc.). Blank = the engine's built-in wording is used.
// Keys MUST match SnapshotCallInterpreter cfg.Phrase(...) call sites and the API allowlist.
interface PhraseDef { key: string; label: string; sub: string; en: string; es: string }
const PHRASE_DEFS: PhraseDef[] = [
  { key: 'clarify',              label: "Didn't catch the caller",   sub: 'When the agent could not understand what the caller wants',      en: "Sorry, I didn't quite catch that. In a few words, how can I help you?", es: 'Disculpe, no entendi bien. En pocas palabras, en que puedo ayudarle?' },
  { key: 'silence.reprompt',     label: 'After silence',             sub: 'A short re-ask when the caller has gone quiet',                   en: "Sorry, I didn't catch that. How can I help you?",                       es: 'Perdon, no le escuche. Como puedo ayudarle?' },
  { key: 'capture.takeYourTime', label: '"Take your time" nudge',    sub: 'Prefix added before repeating a question to a slow caller',      en: 'Take your time. ',                                                      es: 'Un momento, por favor. ' },
  { key: 'wrapup.anythingElse',  label: 'Ask "anything else?"',      sub: 'The wrap-up question before ending a successful call',           en: 'Is there anything else I can help you with?',                           es: 'Hay algo mas en lo que pueda ayudarle?' },
  { key: 'confirm.correction',   label: 'Read-back was wrong',       sub: 'When the caller says the confirmed details are incorrect',       en: 'Sorry about that. What should it be? Please tell me the correct details.', es: 'Disculpe. Por favor digame los datos correctos.' },
  { key: 'goodbye',              label: 'Goodbye (success)',         sub: 'The closing line on the default Thank You (Success) terminal',    en: 'Thank you for calling. Have a great day.',                              es: 'Gracias por llamar. Que tenga un buen dia.' },
  { key: 'wrapup.whatElse',      label: 'Caller said "yes" to anything else', sub: 'Asked when the caller wants something more at the end of the call', en: 'Of course. What else can I help you with?', es: 'Claro. En que mas puedo ayudarle?' },
  { key: 'capture.availabilityUnknown', label: 'Caller asked what is available', sub: 'When the caller asks which days or times you have, and the AI has no calendar', en: "I don't have the calendar in front of me, so our staff will confirm the time with you. Is there a day that works best for you?", es: 'No tengo el calendario a la mano; nuestro personal le confirmara la hora. Tiene algun dia que le funcione mejor?' },
  { key: 'goodbye.failure',      label: "Goodbye (couldn't finish)", sub: 'The closing line when the call could not be completed',           en: "Thank you for calling. I'm sorry we couldn't finish your request just now - our staff will follow up with you.", es: 'Gracias por llamar. Disculpe que no pudimos completar su solicitud; nuestro personal le contactara.' },
];
const PHRASE_HELP: HelpSection[] = [
  ['What it does', 'Overrides the standard lines the AI voice agent speaks - silence re-asks, the "anything else?" wrap-up, goodbyes, and clarification prompts - in your own words, per language.'],
  ['When it fires', 'Each line is spoken at the matching moment in a call. Leave a box blank to keep the built-in wording.'],
  ['Example', 'Change the success goodbye to "Thanks for calling Harlem Wellness - take care!" and every completed call ends with your wording.'],
];


// v12.10.8 (#1160): one component, two Settings areas - Personalization keeps its four, Vocabulary gets Fields + Lists.
export type PzPart = 'personalization' | 'vocabulary';
export default function PersonalizationSections({ onStateChange, part = 'personalization' }: { onStateChange?: (s: PersonalizationState) => void; part?: PzPart } = {}) {
  const queryClient = useQueryClient();
  const { data, isLoading, error } = useQuery<PersonalizationData>({
    queryKey: QKEY,
    queryFn: async () => withRepeat(await api.get<PersonalizationData>('/t2/surface/personalization')),   // v12.10.16 (T113)
  });
  // v12.2.42.0 (#236): Vocabulary loads from a SEPARATE source (the Organization settings DTO carries the
  // entity->label map). Kept independent so a slow/failed org fetch never blocks the four taxonomy sections.
  // v12.3.10 (#296/#298): the entity list comes from the SERVER catalog (VocabularyCatalog.cs) so this
  // page, the token pickers and the engine can never drift apart again. VOCAB_ENTITIES below is kept
  // only as the pre-fetch fallback. Adding 'organization' server-side makes it appear here for free.
  const { data: vocabData, error: vocabError } = useQuery<{ vocabulary?: Record<string, string>; agentPhrases?: Record<string, Record<string, string>>; vocabularyCatalog?: Array<{ token: string; defaultLabel: string; what: string; sub: string; fields: Array<{ key: string; label: string; type?: string; source?: string; datePurpose?: string }> }>; customFields?: Record<string, { label: string; type: string; source?: string; listKey?: string; listColumn?: string; tenantOwned?: boolean; dateRule?: DateRule | null; cleanup?: string; isOn?: boolean }>; customTerms?: Record<string, { what?: string | null }>; fieldOverrides?: Record<string, { label?: string; cleanup?: string; dateRule?: DateRule | null; isOn?: boolean; listKey?: string; listColumn?: string }>; lists?: Record<string, RefList>; managedLists?: Record<string, string>; datePurposes?: DatePurposeInfo[]; dateOrder?: DateOrderInfo }>({
    queryKey: ['t2-org-vocabulary'],
    queryFn: () => api.get<{ vocabulary?: Record<string, string>; agentPhrases?: Record<string, Record<string, string>>; vocabularyCatalog?: Array<{ token: string; defaultLabel: string; what: string; sub: string; fields: Array<{ key: string; label: string; type?: string; source?: string; datePurpose?: string }> }>; customFields?: Record<string, { label: string; type: string; source?: string; listKey?: string; listColumn?: string; tenantOwned?: boolean; dateRule?: DateRule | null; cleanup?: string; isOn?: boolean }>; customTerms?: Record<string, { what?: string | null }>; fieldOverrides?: Record<string, { label?: string; cleanup?: string; dateRule?: DateRule | null; isOn?: boolean; listKey?: string; listColumn?: string }>; lists?: Record<string, RefList>; managedLists?: Record<string, string>; datePurposes?: DatePurposeInfo[]; dateOrder?: DateOrderInfo }>('/t2/settings/organization'),
  });

  const [saved, setSaved] = useState<PersonalizationData | null>(null);
  const [draft, setDraft] = useState<PersonalizationData | null>(null);
  // Add/edit drawer state per taxonomy ({ index: null } = add, { index: n } = edit row n).
  const [ctModal, setCtModal] = useState<ModalState<CallerType> | null>(null);
  const [mcModal, setMcModal] = useState<ModalState<Category> | null>(null);
  const [lbModal, setLbModal] = useState<ModalState<Label> | null>(null);
  const [vocabSaved, setVocabSaved] = useState<Record<string, string> | null>(null);
  // v12.6.2 (#576): which platform field the tenant has opened, as `entity.key`. Read-only by design -
  // a platform field cannot be renamed away or deleted (BDR-001 v1.2 §7.6) and its TYPE is
  // platform-managed (BDR-013 Decision 6). Being able to SEE the type is the whole ask.
  // v12.7.0 (#576): a platform field opens THE DRAWER, read-only - not the inline card 12.6.2 shipped.
  // His verification: "every field now opens inline, wasn't it supposed to open drawer?" It was.
  const [fieldReadOnly, setFieldReadOnly] = useState(false);
  const [vocabDraft, setVocabDraft] = useState<Record<string, string> | null>(null);
  // Server catalog -> the shape this table renders. Falls back to the built-in list until the fetch lands.
  const vocabEntities: VocabEntity[] = useMemo(() => {
    const cat = vocabData?.vocabularyCatalog;
    if (!cat || cat.length === 0) return VOCAB_ENTITIES;
    return cat.map((e) => ({
      token: e.token, what: e.what, sub: e.sub,
      fields: e.fields.map((f) => f.key).join(' · '),
      fieldList: e.fields.map((f) => ({ key: f.key, label: f.label, type: f.type, source: f.source, datePurpose: f.datePurpose })),   // v12.6.2 (#576)
      fallback: e.defaultLabel,
    }));
  }, [vocabData]);

  // v12.3.12 (#314): the fields THIS tenant registered by typing them into a step's Stores box. 12.3.11 recorded
  // them and displayed them nowhere, so Tushar registered medication.name and reasonably concluded it had not
  // saved: "i don't see that in personalization - vocabulary". They belong here with the platform rows, as ONE
  // LINE each - his words: "just as one liner with available tokens no description required as the standard
  // vocabulary." Grouped by entity, because the entity is the unit a label renames.
  const customEntities = useMemo(() => {
    const byEntity = new Map<string, string[]>();
    for (const key of Object.keys(vocabData?.customFields ?? {})) {
      const dot = key.indexOf('.');
      if (dot <= 0) continue;
      const ent = key.slice(0, dot);
      if (vocabEntities.some((e) => e.token.toLowerCase() === ent.toLowerCase())) continue;   // platform-managed
      const list = byEntity.get(ent) ?? [];
      const field = key.slice(dot + 1);
      if (!list.includes(field)) list.push(field);
      byEntity.set(ent, list);
    }
    // v12.10.8.1 (#1233): a term the practice created has a row before it has any field.
    for (const t of Object.keys(vocabData?.customTerms ?? {})) {
      if (vocabEntities.some((e) => e.token.toLowerCase() === t.toLowerCase())) continue;
      if (![...byEntity.keys()].some((k) => k.toLowerCase() === t.toLowerCase())) byEntity.set(t, []);
    }
    return Array.from(byEntity.entries())
      .map(([token, fields]) => ({ token, fields: fields.sort(), what: (vocabData?.customTerms ?? {})[token]?.what ?? '' }))
      .sort((a, b) => a.token.localeCompare(b.token));
  }, [vocabData, vocabEntities]);

  // v12.3.12 (#314 + #323): unregistering is destructive - an integration may be reading the field - so it goes
  // through the same type-the-name gate as every other delete.
  // v12.4.16 (#499): THE FIELDS A TENANT HUNG OFF AN ENTITY, INCLUDING A PLATFORM ONE.
  //
  // customEntities above deliberately SKIPS a platform entity, because #314 was only ever about entities a
  // workflow invented wholesale (medication, test). #499 is the other half: `subject` stays a platform entity
  // and a practice adds subject.accountNumber to it. Those fields were already storable - the registry has
  // taken any "entity.field" key since #311 - and were displayed NOWHERE, which is the same
  // records-but-shows-nothing failure #314 was written to end, one level down.
  const tenantFieldsByEntity = useMemo(() => {
    const byEntity = new Map<string, Array<{ key: string; field: string; label: string; type: string; source: string; listKey: string; isOn: boolean }>>();
    for (const [key, def] of Object.entries(vocabData?.customFields ?? {})) {
      const dot = key.indexOf('.');
      if (dot <= 0) continue;
      const ent = key.slice(0, dot).toLowerCase();
      const list = byEntity.get(ent) ?? [];
      list.push({ key, field: key.slice(dot + 1), label: def?.label || key, type: def?.type || 'text', source: def?.source || 'captured', listKey: def?.listKey ?? '', isOn: def?.isOn !== false });
      byEntity.set(ent, list);
    }
    for (const list of byEntity.values()) list.sort((a, b) => a.field.localeCompare(b.field));
    return byEntity;
  }, [vocabData]);

  // v12.4.16 (#499): the add/edit drawer, and which entity it is adding to. `null` = closed.
  const [fieldDraft, setFieldDraft] = useState<VocabFieldDraft | null>(null);
  const [fieldEditing, setFieldEditing] = useState<string | null>(null);   // the key being edited, or null for new
  const fieldSet = <K extends keyof VocabFieldDraft>(k: K, v: VocabFieldDraft[K]) =>
    setFieldDraft((d) => (d ? { ...d, [k]: v } : d));

  // The entities a tenant field may hang off: every platform entity plus every entity they already registered,
  // labelled with the tenant's own word. "Your field" is the catch-all parent for a brand-new entity (the
  // "Add vocabulary" button below), which is the group BDR-001 v1.2 §7.4 names.
  const drawerEntities = useMemo<[string, string][]>(() => {
    const seen = new Set<string>();
    const out: [string, string][] = [['', 'Choose an entity…']];
    for (const e of vocabEntities) { seen.add(e.token.toLowerCase()); out.push([e.token, vocabDraft?.[e.token] || e.fallback]); }
    for (const e of customEntities) if (!seen.has(e.token.toLowerCase())) { seen.add(e.token.toLowerCase()); out.push([e.token, vocabDraft?.[e.token] || e.token]); }
    return out;
  }, [vocabEntities, customEntities, vocabDraft]);

  // v12.4.16 (#499): KEY UNIQUENESS IS THE PLATFORM'S (BDR-001 v1.2 §7.6), so it is checked before the save and
  // said in the drawer rather than swallowed by the server's merge. Two cases, two different sentences:
  // shadowing a PLATFORM field is refused outright (the API refuses it too - ShadowsPlatformField); colliding
  // with the tenant's own field is only a conflict when it is not the one being edited.
  const platformFieldKeys = useMemo(() => {
    const set = new Set<string>();
    for (const e of vocabData?.vocabularyCatalog ?? [])
      for (const f of e.fields) set.add(`${e.token}.${f.key}`.toLowerCase());
    return set;
  }, [vocabData]);
  const fieldKeyError = useMemo(() => {
    if (!fieldDraft) return undefined;
    const ent = (fieldDraft.entity ?? '').trim().toLowerCase();
    const key = (fieldDraft.key ?? '').trim();
    if (!ent || !key) return undefined;
    if (!/^[A-Za-z][A-Za-z0-9_]*$/.test(key)) return 'Start with a letter, then letters, numbers or underscores.';
    const full = `${ent}.${key}`.toLowerCase();
    if (platformFieldKeys.has(full)) return 'That is a built-in field on this entity. Rename its label instead — you cannot replace it.';
    if (full !== (fieldEditing ?? '').toLowerCase() && Object.keys(vocabData?.customFields ?? {}).some((k) => k.toLowerCase() === full))
      return 'You already have a field with that key on this entity.';
    return undefined;
  }, [fieldDraft, fieldEditing, platformFieldKeys, vocabData]);

  const saveField = useMutation({
    mutationFn: async (d: VocabFieldDraft) => {
      const key = `${(d.entity ?? '').trim()}.${(d.key ?? '').trim()}`;
      // The endpoint MERGES, so one field is posted on its own and nothing else in the registry is touched.
      await api.put('/t2/settings/organization/custom-fields', {
        // v12.4.16 (#500): listKey travels with the field; the API drops it for any type but `choice`.
        [key]: { label: d.name.trim() || key, type: d.type, source: d.source ?? 'captured', listKey: d.listKey ?? '', listColumn: d.listKey ? (d.listColumn || 'name') : '', dateRule: d.dateRule ?? null,   // v12.10.10 (#1406): listColumn
          cleanup: d.cleanup ?? '', isOn: d.isOn !== false },   // v12.10.8 (#1190 cleanup kept, #1227 On / Off)
      });
      return key;
    },
    onSuccess: (key) => {
      queryClient.invalidateQueries({ queryKey: ['t2-org-vocabulary'] });
      setFieldDraft(null); setFieldEditing(null);
      toast('success', 'Field saved', `{${key}} is now offered everywhere a built-in field is.`);
    },
    onError: () => toast('error', 'Could not save the field', 'Nothing was changed - try again.'),
  });

  // ── v12.8.0 (#659): A PLATFORM FIELD SAVES NOW, TO ITS OWN STORE. ─────────────────────────────────
  //
  // `custom-fields` cannot take this: the controller refuses a platform key outright
  // (`if (ShadowsPlatformField(key)) continue;`), which is why Input cleanup set here in 12.7.3 was accepted
  // by the screen and silently dropped - a control that takes a value and discards it, #560's family.
  //
  // `vocabulary` cannot take it either, and this is the part I had wrong until I read the filter: #335
  // widened that map to a tenant's own ENTITIES, not to fields. Its check is
  // `VocabEntities.Contains(key) || customEntities.Contains(key)`, and "subject.dob" satisfies neither.
  //
  // So both editable properties go to `fieldOverrides`, which exists for exactly this and nothing else.
  // It cannot carry a key or a type, so BDR-001 §7.6 and BDR-013 Decision 6 stand untouched.
  const savePlatformField = useMutation({
    mutationFn: async (d: VocabFieldDraft) => {
      const key = `${(d.entity ?? '').trim()}.${(d.key ?? '').trim()}`;
      // MERGES, like custom-fields: one field posted alone leaves every other override where it was.
      await api.put('/t2/settings/organization/field-overrides', {
        [key]: { label: (d.name ?? '').trim(), cleanup: d.cleanup ?? '', dateRule: d.dateRule ?? null, isOn: d.isOn !== false,   // v12.10.8 (#1227)
          listKey: d.listKey ?? '', listColumn: d.listKey ? (d.listColumn || 'name') : '' },   // v12.10.10 (#1406): a platform field ties to a list too
      });
      return key;
    },
    onSuccess: (key) => {
      queryClient.invalidateQueries({ queryKey: ['t2-org-vocabulary'] });
      setFieldDraft(null); setFieldEditing(null); setFieldReadOnly(false);
      toast('success', 'Field saved', `Your settings for {${key}} are saved. Its key and type are unchanged.`);
    },
    onError: () => toast('error', 'Could not save the field', 'Nothing was changed - try again.'),
  });

  // v12.8.0 (#659): opens with the tenant's OWN label and cleanup if they have set them, so the drawer shows
  // what is in force rather than the platform default sitting underneath it.
  function openPlatformField(entity: string, f: VocabField) {
    setFieldEditing(null);
    setFieldReadOnly(true);
    const ov = (vocabData?.fieldOverrides ?? {})[`${entity}.${f.key}`];
    setFieldDraft({
      name: ov?.label || f.label || f.key,
      key: f.key,
      type: f.type || 'text',
      entity,
      source: f.source || 'captured',
      cleanup: ov?.cleanup ?? '',
      dateRule: ov?.dateRule ?? null,          // v12.9.27 (#1045)
      datePurpose: f.datePurpose ?? '',        // v12.9.27 (#1045)
      isOn: ov?.isOn !== false,                // v12.10.8 (#1227)
      listKey: ov?.listKey ?? '', listColumn: ov?.listColumn ?? '',   // v12.10.10 (#1406)
    });
  }

  function openAddField(entity: string) {
    setFieldReadOnly(false);
    setFieldEditing(null);
    setFieldDraft({ name: '', key: '', type: 'text', entity, source: 'captured', isOn: true });
  }
  function openEditField(entity: string, f: { key: string; field: string; label: string; type: string; source: string; listKey?: string }) {
    setFieldReadOnly(false);
    setFieldEditing(f.key);
    const cf = (vocabData?.customFields ?? {})[f.key];
    setFieldDraft({ name: f.label, key: f.field, type: f.type, entity, source: f.source, listKey: f.listKey ?? '',
      dateRule: cf?.dateRule ?? null,   // v12.9.27 (#1045)
      cleanup: cf?.cleanup ?? '', isOn: cf?.isOn !== false, listColumn: cf?.listColumn ?? '' });   // v12.10.8 (#1190 #1227); v12.10.10 (#1406)
  }


  // ── v12.4.16 (#500): LISTS ────────────────────────────────────────────────────────────────────────
  // Draft/saved mirrors Vocabulary exactly (structuredClone in, compare out) so the section behaves like its
  // neighbours: Save all reaches it, the nav dot marks it dirty, Discard puts it back.
  const [listsSaved, setListsSaved] = useState<Record<string, RefList> | null>(null);
  const [listsDraft, setListsDraft] = useState<Record<string, RefList> | null>(null);
  // Which list is expanded, which entry is open in the drawer, and which list the import panel is aimed at.
  const [openList, setOpenList] = useState<string | null>(null);
  // v12.6.0 (#558): aliasText is the RAW text in the "Caller might say" box, kept beside the entry and
  // split into aliases only when the drawer is committed. See the input below for why it cannot be
  // derived from entry.aliases on every keystroke.
  const [entryDraft, setEntryDraft] = useState<EntryDraftState | null>(null);
  // v12.10.10 (#1406): the New / Edit list drawer.
  const [listDrawer, setListDrawer] = useState<{ key: string | null; name: string; description: string; isOn: boolean; offerCap: number } | null>(null);
  // v12.10.10 (#1407): "Save your changes first?" before a drawer opens over unsaved page edits.
  const [pendingOpen, setPendingOpen] = useState<{ open: () => void } | null>(null);
  // v12.10.10 (#1406): the organization's languages (the rail on Caller might say / AI says back) and connected systems.
  const { data: aiLangData } = useQuery<{ languages?: { code: string; displayName?: string }[] }>({
    queryKey: ['t2-ai-agent'], queryFn: () => api.get('/t2/settings/ai-agent'), staleTime: 60_000 });
  const orgLangs = useMemo(() => {
    const out: string[] = [];
    for (const l of aiLangData?.languages ?? []) { const c = (l.code ?? '').toLowerCase().split(/[-_]/)[0]; if (c && !out.includes(c)) out.push(c); }
    return out.length ? out : ['en', 'es'];
  }, [aiLangData]);
  const { data: integData } = useQuery<{ connectedSystems?: { id: string; name: string; type: string }[] }>({
    queryKey: ['t2-integrations'], queryFn: () => api.get('/t2/settings/integrations'), staleTime: 60_000 });
  const systemNames = useMemo(() => (integData?.connectedSystems ?? []).map((c) => c.name).filter(Boolean), [integData]);
  // v12.10.10 (#1406): which fields are tied to a list (custom fields and platform overrides), for "Tied to" and C4.
  const tiedFieldsOf = (listKey: string): string[] => {
    const k = listKey.toLowerCase();
    const a = Object.entries(vocabData?.customFields ?? {}).filter(([, f]) => (f?.listKey ?? '').toLowerCase() === k).map(([t]) => t);
    const b = Object.entries(vocabData?.fieldOverrides ?? {}).filter(([, f]) => (f?.listKey ?? '').toLowerCase() === k).map(([t]) => t);
    return [...a, ...b];
  };
  // v12.10.10.1 (#1419): the column a tied field reads, for the Edit list chip ('{provider.name} · Name').
  const tiedColumnWord = (token: string): string => {
    const f = (vocabData?.customFields?.[token] ?? vocabData?.fieldOverrides?.[token]) as { listColumn?: string } | undefined;
    const c = (f?.listColumn || 'name').toLowerCase();
    const words: Record<string, string> = { name: 'Name', description: 'Description', id: 'Their id', custom1: 'Custom field 1', custom2: 'Custom field 2' };
    return words[c] ?? c;
  };
  // v12.10.10 (#1407): every list change from a drawer or a row control SAVES at once - drawer work never sits in the bar.
  const commitLists = (next: Record<string, RefList>) => { setListsDraft(next); saveLists.mutate(next); };
  const [importFor, setImportFor] = useState<string | null>(null);
  const [removeList, setRemoveList] = useState<string | null>(null);

  const saveLists = useMutation({
    mutationFn: async (m: Record<string, RefList>) => { await api.put('/t2/settings/organization/lists', m); return m; },
    onSuccess: (m) => {
      setListsSaved(structuredClone(m)); setListsDraft(structuredClone(m));
      queryClient.setQueryData(['t2-org-vocabulary'], (prev: object | undefined) => ({ ...(prev ?? {}), lists: m }));
      toast('success', 'Lists saved');
    },
    onError: (e) => saveErrorToast(e, 'Could not save your lists'),
  });
  // ── v12.6.0 (#560): REMOVE THE LIST, OR SAY YOU DID NOT. ────────────────────────────────────────
  //
  // Tushar, 2026-09-21: "i added a new list, clicked on remove list, it gave roaster list is deleted
  // but it was still there i clicked on save changes but it did not change anything."
  //
  // He removed a list he had just added and NOT yet saved. The old code fired the server DELETE for a
  // key the server has never heard of, that call succeeded trivially, the success toast fired - and the
  // local draft was never touched, so the list stayed on screen and the next Save wrote it straight
  // back. A confirmation that a thing is gone, shown while the thing is in front of you, is worse than
  // an error: it teaches a tenant not to believe our messages.
  //
  // Two cases now, told apart by whether the list exists in `listsSaved` (which IS the server's copy):
  //   draft-only  remove it from the draft. No request, and the toast is TRUE - it is gone from the
  //               screen and there was never anything on the server to delete.
  //   on server   DELETE, then drop it from saved AND draft locally.
  //
  // NOTE THE COUPLING WITH #559, because it is what makes the local update necessary rather than tidy.
  // This used to call invalidateQueries and let the refetch re-seed the screen. With #559's guard in
  // place a DIRTY draft is no longer re-seeded - correctly - so the refetch would leave the removed
  // list sitting in the draft and the defect would come back wearing a different cause. Two items that
  // have to land together.
  const removeListMut = useMutation({
    mutationFn: (key: string) => api.delete(`/t2/settings/organization/lists/${encodeURIComponent(key)}`),
    onSuccess: (_res, key) => {
      queryClient.invalidateQueries({ queryKey: ['t2-org-vocabulary'] });   // v12.10.10 (#1406 C4): the server untied its fields
      setListsSaved((m) => dropList(m, key));
      setListsDraft((m) => dropList(m, key));
      queryClient.setQueryData(['t2-org-vocabulary'], (prev: { lists?: Record<string, RefList> } | undefined) =>
        (prev ? { ...prev, lists: dropList(prev.lists ?? {}, key) ?? {} } : prev));
      setOpenList((k) => (k === key ? null : k));
      setRemoveList(null);
      toast('success', 'List removed');
    },
    onError: () => toast('error', 'Could not remove the list', 'Nothing was changed - try again.'),
  });

  // A list the server has never seen is removed from the draft and nothing else. `listsSaved` is the
  // server's copy, so its absence there is the whole test.
  const confirmRemoveList = (key: string) => {
    if (listsSaved && !listsSaved[key]) {
      setListsDraft((m) => dropList(m, key));
      setOpenList((k) => (k === key ? null : k));
      setRemoveList(null);
      toast('success', 'List removed', 'It had not been saved yet, so there was nothing to remove on the server.');
      return;
    }
    removeListMut.mutate(key);
  };

  // v12.4.16 (#500): the Lists a `choice` field may be backed by. Read from the DRAFT, so a list created and
  // not yet saved is still offered - and from saved too, because the draft is null until the fetch lands.
  const drawerLists = useMemo<[string, string][]>(
    () => Object.values(listsDraft ?? listsSaved ?? {}).map((L) => [L.key, L.name] as [string, string]).sort((a, b) => a[1].localeCompare(b[1])),
    [listsDraft, listsSaved]);

  const [removeField, setRemoveField] = useState<{ token: string } | null>(null);

  // ══ v12.10.8.1 (#1233): THE TERM WINDOW - add a term of the practice's own, or edit one. ══════════════════════
  // Tushar 10/5: "add will just allow to add or edit Vocabulary. nothing else" - Term, Your label, What it is. No
  // first field: "the field needs to be defined with all the parameters", so fields come after, from + Add field.
  const [termDraft, setTermDraft] = useState<{ term: string; label: string; what: string; editing: boolean } | null>(null);
  const openTerm = (token: string | null) => setTermDraft(token
    ? { term: token, label: vocabDraft?.[token] ?? '', what: (vocabData?.customTerms ?? {})[token]?.what ?? '', editing: true }
    : { term: '', label: '', what: '', editing: false });
  const termError = (() => {
    if (!termDraft || termDraft.editing) return null;
    const t = termDraft.term.trim();
    if (!t) return null;
    if (!/^[a-z][a-z0-9]{1,39}$/.test(t)) return 'Lowercase letters (and digits after the first letter), 2 to 40 characters - no spaces or dots.';
    if (vocabEntities.some((e) => e.token.toLowerCase() === t)) return `"${t}" is a built-in term - pick another word.`;
    if (customEntities.some((e) => e.token.toLowerCase() === t)) return `"${t}" already exists - use its Edit.`;
    return null;
  })();
  const saveTerm = useMutation({
    mutationFn: (d: { term: string; label: string; what: string }) =>
      api.put(`/t2/settings/organization/custom-terms/${encodeURIComponent(d.term)}`, { label: d.label.trim() || null, what: d.what.trim() || null }),
    onSuccess: (_r, d) => {
      queryClient.invalidateQueries({ queryKey: ['t2-org-vocabulary'] });
      if (d.label.trim()) { setVocabDraft((m) => ({ ...(m ?? {}), [d.term]: d.label.trim() })); setVocabSaved((m) => ({ ...(m ?? {}), [d.term]: d.label.trim() })); }
      setTermDraft(null);
      toast('success', termDraft?.editing ? 'Term saved' : 'Term added', termDraft?.editing ? undefined : 'Add its fields with + Add field.');
    },
    onError: (e) => saveErrorToast(e, 'the term'),
  });
  const removeCustom = useMutation({
    mutationFn: (token: string) => api.delete(`/t2/settings/organization/custom-fields/${encodeURIComponent(token)}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['t2-org-vocabulary'] });
      setRemoveField(null);
      toast('success', 'Field removed', 'It is no longer offered by the token pickers.');
    },
    onError: () => toast('error', 'Could not remove the field', 'Nothing was changed - try again.'),
  });

  // v12.2.44.0 (#254): agent phrases (key -> {lang -> text}); shares the org-settings fetch with vocabulary.
  const [phrasesSaved, setPhrasesSaved] = useState<Record<string, Record<string, string>> | null>(null);
  const [phrasesDraft, setPhrasesDraft] = useState<Record<string, Record<string, string>> | null>(null);

  // ── v12.6.0 (#559): A FETCH MUST NEVER OVERWRITE UNSAVED WORK. ──────────────────────────────────
  //
  // Tushar, 2026-09-21: "i added a provider for provider list, didn't click on save all changes and
  // added a new list - locations, added an entry there but provider list got empty."
  //
  // Every one of the four seed effects below read `if (!x) return;` and then set BOTH halves:
  //
  //     setListsSaved(structuredClone(seed));
  //     setListsDraft(structuredClone(seed));   // <- unconditional
  //
  // The draft is the tenant's unsaved work. Seeding it from the fetch is right exactly ONCE, on first
  // load. After that, every re-run is a silent discard - and the effect re-runs whenever the query
  // object changes: a sibling section's save (setQueryData), an invalidateQueries (which #560's remove
  // fires), or React Query's own refetch-on-window-focus. THAT is why the loss looked random and
  // unrelated to what he had just clicked. It was the window regaining focus.
  //
  // THIS IS NOT A LISTS BUG. All four drafts on this screen - Personalization, Vocabulary, Agent
  // phrases, Lists - had the identical shape, so unsaved work in ANY section could vanish. Fixing only
  // the one he reported would have left three, which is the pattern OPERATIONS section 25 is about.
  //
  // The rule the screen already promises, in its own buttons: nothing is written until Save, and
  // nothing is LOST until Discard. `saved` still tracks the server on every fetch, so the section stays
  // correctly marked dirty and Save still writes - only the DRAFT is protected.
  //
  // A ref rather than state on purpose: reading it inside these effects must not add it to their
  // dependencies, or they would re-run on every keystroke and re-seed continuously.
  const draftDirty = useRef({ main: false, vocab: false, phrases: false, lists: false });

  useEffect(() => {
    if (!data) return;
    setSaved(structuredClone(data));
    setDraft((prev) => (prev === null || !draftDirty.current.main ? structuredClone(data) : prev));
  }, [data]);

  // Seed vocab draft/saved from the org map, defaulting each entity to its sensible fallback label so the
  // table is never blank and an untouched tenant reads as not-dirty (draft === saved on load).
  useEffect(() => {
    if (!vocabData) return;
    const seed: Record<string, string> = {};
    for (const e of vocabEntities) seed[e.token] = vocabData.vocabulary?.[e.token] ?? e.fallback;
    // v12.3.12.4 (#335, second half): this loop walks the six PLATFORM entities only, so a stored label for a
    // custom entity was never read back - the input rendered empty and its placeholder made it look unsaved.
    // 12.3.12.3 fixed the WRITE path and I did not check the read path, which is the third time this cycle I
    // have fixed one direction of a round trip (#307 writer+reader with a broken pipe between them; #311 a
    // registry with no read path; now this). Seed anything already stored that the catalog does not cover.
    for (const [token, label] of Object.entries(vocabData.vocabulary ?? {}))
      if (!(token in seed) && typeof label === 'string' && label.trim()) seed[token] = label;
    setVocabSaved({ ...seed });
    setVocabDraft((prev) => (prev === null || !draftDirty.current.vocab ? { ...seed } : prev));   // v12.6.0 (#559)
  }, [vocabData]);

  // v12.4.16 (#500): seed Lists from the same org fetch.
  useEffect(() => {
    if (!vocabData) return;
    const seed = structuredClone(vocabData.lists ?? {}) as Record<string, RefList>;
    setListsSaved(structuredClone(seed));
    setListsDraft((prev) => (prev === null || !draftDirty.current.lists ? structuredClone(seed) : prev));   // v12.6.0 (#559)
  }, [vocabData]);

  // v12.2.44.0 (#254): seed agent-phrase draft/saved from the same org fetch (blank per key/lang = built-in default).
  useEffect(() => {
    if (!vocabData) return;
    const seed: Record<string, Record<string, string>> = {};
    for (const d of PHRASE_DEFS) seed[d.key] = { ...(vocabData.agentPhrases?.[d.key] ?? {}) };
    setPhrasesSaved(structuredClone(seed));
    setPhrasesDraft((prev) => (prev === null || !draftDirty.current.phrases ? structuredClone(seed) : prev));   // v12.6.0 (#559)
  }, [vocabData]);

  function onSaved(fresh: PersonalizationData) {
    setSaved(structuredClone(fresh));
    setDraft(structuredClone(fresh));
    queryClient.setQueryData(QKEY, fresh);
  }

  // v12.1.23.0: each section saves to its own REAL tenant table via a per-section PUT (replace-all for
  // the taxonomy lists). The endpoints return only { saved, updatedAt }, and since config applies live we
  // patch saved/draft from the draft we just sent. NOTE: the override flags live on the single
  // personalization_settings row (alongside grouping), NOT on the taxonomy list — so the Caller types /
  // Categories saves ALSO write the settings endpoint so their override toggle actually persists.
  const putSettings = (d: PersonalizationData) => api.put('/t2/surface/personalization/settings', {
    overrides: d.overrides, grouping: { sameCaller: d.grouping.sameCaller, appendWindow: d.grouping.appendWindow },
    // v12.10.16 (T113): Repeat callers + Automatic status ride the same save
    repeatCallers: { onCall: d.grouping.onCall ?? 'off', onCallWindow: d.grouping.onCallWindow ?? 10, sameDay: d.grouping.sameDay ?? false, autoCompleteEmptyMissed: d.grouping.autoComplete ?? false, refreshSeconds: d.grouping.refreshSeconds ?? 60,
      classic: d.grouping.classic ?? false, lines: d.grouping.lines ?? {},   // v12.10.18 (#1863)
      routes: d.grouping.routes ?? {},   // v12.10.23 (#2068)
      noDetailsReplies: d.grouping.noDetailsReplies ?? {},   // v12.10.26 (#2128)
      needsLive: d.grouping.needsLive ?? 'local', needsVoicemail: d.grouping.needsVoicemail ?? 'local',
      needsSpokenWords: d.grouping.needsSpokenWords ?? 25, confirmRequiredAt: d.grouping.confirmRequiredAt ?? 3 },   // v12.10.19 (#1924 #1925)
  });
  const saveCallerTypes = useMutation({
    mutationFn: async (d: PersonalizationData) => { await api.put('/t2/surface/personalization/caller-types', d.callerTypes); await putSettings(d); return d; },
    onSuccess: (d: PersonalizationData) => { onSaved(d); toast('success', 'Caller types saved'); },
    onError: (err) => saveErrorToast(err),   // v12.3.12.5 (#334): a 401 says the session ended, not 'try again'
  });
  const saveCategories = useMutation({
    mutationFn: async (d: PersonalizationData) => { await api.put('/t2/surface/personalization/categories', d.categories); await putSettings(d); return d; },
    onSuccess: (d: PersonalizationData) => { onSaved(d); toast('success', 'Categories saved'); },
    onError: (err) => saveErrorToast(err),   // v12.3.12.5 (#334): a 401 says the session ended, not 'try again'
  });
  const saveLabels = useMutation({
    mutationFn: async (d: PersonalizationData) => { await api.put('/t2/surface/personalization/labels', d.labels); return d; },
    onSuccess: (d: PersonalizationData) => { onSaved(d); toast('success', 'Labels saved'); },
    onError: (err) => saveErrorToast(err),   // v12.3.12.5 (#334): a 401 says the session ended, not 'try again'
  });
  const groupingSaveLabel = useRef('Repeat callers saved');   // v12.10.17 (#1758)
  // v12.10.22 (#2003): the toast names what was saved - Save all / save-before-open used the Repeat callers default even when only
  // Messages workspace had changed.
  const groupingLabelFor = (mw: boolean, rc: boolean) =>
    mw && rc ? 'Messages workspace and Repeat callers saved' : mw ? 'Messages workspace saved' : 'Repeat callers saved';
  const saveGrouping = useMutation({
    // overrides + grouping share the single personalization_settings row.
    mutationFn: async (d: PersonalizationData) => { await putSettings(d); return d; },
    onSuccess: (d: PersonalizationData) => { onSaved(d); toast('success', groupingSaveLabel.current); groupingSaveLabel.current = 'Repeat callers saved'; },   // v12.10.17 (#1758): the card that saved
    onError: (err) => saveErrorToast(err),   // v12.3.12.5 (#334): a 401 says the session ended, not 'try again'
  });
  const saveVocabulary = useMutation({
    // entity->label map lives in tenant_settings["vocabulary"] via the Organization settings controller.
    mutationFn: async (m: Record<string, string>) => { await api.put('/t2/settings/organization/vocabulary', m); return m; },
    // v12.2.44.0 (#254): merge into the cached org blob so a vocab save doesn't drop cached agentPhrases.
    onSuccess: (m) => { setVocabSaved({ ...m }); setVocabDraft({ ...m }); queryClient.setQueryData(['t2-org-vocabulary'], (prev: { vocabulary?: Record<string, string>; agentPhrases?: Record<string, Record<string, string>> } | undefined) => ({ ...(prev ?? {}), vocabulary: m }));
      // The label is what a tenant renamed; say which one landed rather than a bare "Saved".
      // v12.3.12 (#327): the old second line ("Your labels are in use everywhere - pickers, spoken lines and
      // summaries") sits directly under the Categories and Labels sections and read as if it were about them.
      // Tushar: "success toast comes but what is this other line your categories and labels here?"
      toast('success', 'Vocabulary saved'); },
    onError: (err) => saveErrorToast(err),   // v12.3.12.5 (#334): a 401 says the session ended, not 'try again'
  });
  const savePhrases = useMutation({
    // agent phrases live in tenant_settings["agentPhrases"] via the Organization settings controller.
    mutationFn: async (m: Record<string, Record<string, string>>) => { await api.put('/t2/settings/organization/agent-phrases', m); return m; },
    onSuccess: (m) => { setPhrasesSaved(structuredClone(m)); setPhrasesDraft(structuredClone(m)); queryClient.setQueryData(['t2-org-vocabulary'], (prev: { vocabulary?: Record<string, string>; agentPhrases?: Record<string, Record<string, string>> } | undefined) => ({ ...(prev ?? {}), agentPhrases: m })); toast('success', 'Agent phrases saved'); },
    onError: (err) => saveErrorToast(err),   // v12.3.12.5 (#334): a 401 says the session ended, not 'try again'
  });

  const eq = (a: unknown, b: unknown) => JSON.stringify(a) === JSON.stringify(b);
  // v12.10.17 (#1758): Repeat callers and Automatic status are two cards over ONE saved grouping object - each card is dirty
  // only for its own keys (Automatic status owns autoComplete; Repeat callers owns the rest), so one edit is one unsaved change.
  // v12.10.18 (#1864, UI-PROTO-T148 v1.10 LOCKED): TWO sections over the one saved row - "Repeat callers" (on the call) owns
  // RC_KEYS; "Messages workspace" (grouping, refresh, Automatic status moved in) owns MW_KEYS. Each is dirty for its own keys only.
  const pickG = (g: Grouping, keys: readonly (keyof Grouping)[]) => Object.fromEntries(keys.map((k) => [k, k === 'lines' || k === 'routes' || k === 'noDetailsReplies' ? (g[k] ?? {}) : g[k]]));   // v12.10.23 (#2068): routes like lines
  const repeatDirtyOf = (a: PersonalizationData, b: PersonalizationData) => !eq(pickG(a.grouping, RC_KEYS), pickG(b.grouping, RC_KEYS));
  const autoDirtyOf = (a: PersonalizationData, b: PersonalizationData) => !eq(pickG(a.grouping, MW_KEYS), pickG(b.grouping, MW_KEYS));

  // Report per-section dirty + save/discard-all up to the Settings shell (mirrors CallHandlingSections).
  // Note: the override strips live inside the Caller types / Categories sections, so overrides.callerType
  // is part of the callerTypes section's dirty tuple and overrides.category part of categories'. The
  // grouping section owns grouping{}. (overrides also travels with grouping to the /settings endpoint —
  // saving grouping persists the current overrides too, which is fine as they apply live.)
  useEffect(() => {
    // v12.6.0 (#559): refresh the seed guard FIRST, before the early return - a screen with no
    // onStateChange still has drafts worth protecting, and this effect already re-runs on exactly the
    // eight values the comparison needs, so it costs nothing extra.
    draftDirty.current = {
      main:    !!(draft && saved) && !eq(draft, saved),
      vocab:   !!(vocabDraft && vocabSaved) && !eq(vocabDraft, vocabSaved),
      phrases: !!(phrasesDraft && phrasesSaved) && !eq(phrasesDraft, phrasesSaved),
      lists:   !!(listsDraft && listsSaved) && !eq(listsDraft, listsSaved),
    };
    if (!draft || !saved || !onStateChange) return;
    const dirty: PzDirtyMap = {
      callerTypes: !eq([draft.callerTypes, draft.overrides.callerType], [saved.callerTypes, saved.overrides.callerType]),
      categories: !eq([draft.categories, draft.overrides.category], [saved.categories, saved.overrides.category]),
      labels: !eq(draft.labels, saved.labels),
      grouping: repeatDirtyOf(draft, saved),     // v12.10.17 (#1758)
      autoStatus: autoDirtyOf(draft, saved),     // v12.10.17 (#1758)
      vocabulary: !!(vocabDraft && vocabSaved) && !eq(vocabDraft, vocabSaved),
      agentPhrases: !!(phrasesDraft && phrasesSaved) && !eq(phrasesDraft, phrasesSaved),
      lists: !!(listsDraft && listsSaved) && !eq(listsDraft, listsSaved),   // v12.4.16 (#500)
    };
    onStateChange({
      dirty,
      anyDirty: Object.values(dirty).some(Boolean),
      saveAll: async () => {
        try {
          if (dirty.callerTypes) await saveCallerTypes.mutateAsync(draft);
          if (dirty.categories) await saveCategories.mutateAsync(draft);
          if (dirty.labels) await saveLabels.mutateAsync(draft);
          if (dirty.grouping || dirty.autoStatus) { groupingSaveLabel.current = groupingLabelFor(!!dirty.autoStatus, !!dirty.grouping); await saveGrouping.mutateAsync(draft); }   // v12.10.17 (#1758): one row, both cards · v12.10.22 (#2003)
          if (dirty.vocabulary && vocabDraft) await saveVocabulary.mutateAsync(vocabDraft);
          if (dirty.agentPhrases && phrasesDraft) await savePhrases.mutateAsync(phrasesDraft);
          if (dirty.lists && listsDraft) await saveLists.mutateAsync(listsDraft);   // v12.4.16 (#500)
        } catch { /* mutation error surfaces the failure */ }
      },
      discardAll: () => { setDraft(saved ? structuredClone(saved) : draft); setVocabDraft(vocabSaved ? { ...vocabSaved } : vocabDraft); setPhrasesDraft(phrasesSaved ? structuredClone(phrasesSaved) : phrasesDraft); setListsDraft(listsSaved ? structuredClone(listsSaved) : listsDraft); },
    });
  }, [draft, saved, vocabDraft, vocabSaved, phrasesDraft, phrasesSaved, listsDraft, listsSaved, onStateChange]); // eslint-disable-line react-hooks/exhaustive-deps

  if (error) return <div className="settings-error">Personalization settings could not be loaded. If this persists right after an update, the tenant database migration may not have been applied yet.</div>;
  if (isLoading || !draft || !saved) return <div className="settings-loading">Loading Personalization settings…</div>;

  const ctDirty = !eq([draft.callerTypes, draft.overrides.callerType], [saved.callerTypes, saved.overrides.callerType]);
  const catDirty = !eq([draft.categories, draft.overrides.category], [saved.categories, saved.overrides.category]);
  const lbDirty = !eq(draft.labels, saved.labels);
  const grDirty = repeatDirtyOf(draft, saved);   // v12.10.17 (#1758): Repeat callers' own keys only
  const asDirty = autoDirtyOf(draft, saved);     // v12.10.17 (#1758): Automatic status' own key only
  // v12.10.17 (#1758): one card's Save / Discard touches only that card's keys - the other card's unsaved edit is neither saved
  // with it nor wiped by it (the saved value of the untouched keys is sent as it is).
  // v12.10.18 (#1864): 'repeat' = Repeat callers (RC_KEYS), 'auto' = Messages workspace (MW_KEYS). A card's Save sends ITS keys from
  // the draft and the other card's SAVED values; the other card's unsaved edit survives the save.
  const keysOf = (card: 'repeat' | 'auto') => (card === 'auto' ? MW_KEYS : RC_KEYS);
  const otherOf = (card: 'repeat' | 'auto') => (card === 'auto' ? RC_KEYS : MW_KEYS);
  const saveGroupingCard = (card: 'repeat' | 'auto') => {
    if (!draft || !saved) return;
    const sent: PersonalizationData = { ...saved, grouping: { ...saved.grouping, ...pickG(draft.grouping, keysOf(card)) } as Grouping };
    const keepOther = pickG(draft.grouping, otherOf(card));
    groupingSaveLabel.current = card === 'auto' ? 'Messages workspace saved' : 'Repeat callers saved';
    saveGrouping.mutate(sent, {
      onSuccess: () => setDraft((d) => (d ? { ...d, grouping: { ...d.grouping, ...keepOther } as Grouping } : d)),
    });
  };
  const discardGroupingCard = (card: 'repeat' | 'auto') => setDraft((d) => (d && saved ? {
    ...d, grouping: { ...d.grouping, ...pickG(saved.grouping, keysOf(card)) } as Grouping,
  } : d));
  const vocabDirty = !!(vocabDraft && vocabSaved) && !eq(vocabDraft, vocabSaved);
  const agentPhrasesDirty = !!(phrasesDraft && phrasesSaved) && !eq(phrasesDraft, phrasesSaved);   // v12.2.44.0 (#254)
  const listsDirty = !!(listsDraft && listsSaved) && !eq(listsDraft, listsSaved);                  // v12.4.16 (#500)
  // v12.10.10 (#1407): the edits made directly on the PAGE (never drawer work) - what "Save your changes first?" lists.
  const pageDirtyNames = [
    ctDirty && 'Caller types', catDirty && 'Categories', lbDirty && 'Labels', asDirty && 'Messages workspace', grDirty && 'Repeat callers',   // v12.10.18 (#1864)
    vocabDirty && 'Fields', agentPhrasesDirty && 'Agent phrases',
  ].filter(Boolean) as string[];
  const guardOpen = (open: () => void) => { if (pageDirtyNames.length > 0) setPendingOpen({ open }); else open(); };
  const savePageThenOpen = async (open: () => void) => {
    try {
      if (draft && ctDirty) await saveCallerTypes.mutateAsync(draft);
      if (draft && catDirty) await saveCategories.mutateAsync(draft);
      if (draft && lbDirty) await saveLabels.mutateAsync(draft);
      if (draft && (grDirty || asDirty)) { groupingSaveLabel.current = groupingLabelFor(asDirty, grDirty); await saveGrouping.mutateAsync(draft); }   // v12.10.17 (#1758) · v12.10.22 (#2003)
      if (vocabDirty && vocabDraft) await saveVocabulary.mutateAsync(vocabDraft);
      if (agentPhrasesDirty && phrasesDraft) await savePhrases.mutateAsync(phrasesDraft);
      open();
    } catch { /* the mutation's own toast says what failed; the drawer stays closed */ }
  };
  const discardPageThenOpen = (open: () => void) => {
    setDraft(saved ? structuredClone(saved) : draft); setVocabDraft(vocabSaved ? { ...vocabSaved } : vocabDraft);
    setPhrasesDraft(phrasesSaved ? structuredClone(phrasesSaved) : phrasesDraft);
    open();
  };
  // v12.10.10 (#1407): a Personalization drawer's Save writes at once (it opens only on a clean page - guardOpen).
  const saveListNow = (fn: (d: PersonalizationData) => PersonalizationData, save: (d: PersonalizationData) => void) => {
    if (!draft) return; const next = fn(structuredClone(draft)); setDraft(next); save(next);
  };

  const setCallerTypes = (fn: (list: CallerType[]) => CallerType[]) => setDraft((d) => (d ? { ...d, callerTypes: fn(structuredClone(d.callerTypes)) } : d));
  const setCategories = (fn: (list: Category[]) => Category[]) => setDraft((d) => (d ? { ...d, categories: fn(structuredClone(d.categories)) } : d));
  const setLabels = (fn: (list: Label[]) => Label[]) => setDraft((d) => (d ? { ...d, labels: fn(structuredClone(d.labels)) } : d));
  const setOverride = (key: keyof Overrides, val: boolean) => setDraft((d) => (d ? { ...d, overrides: { ...d.overrides, [key]: val } } : d));
  const setGrouping = (p: Partial<Grouping>) => setDraft((d) => (d ? { ...d, grouping: { ...d.grouping, ...p } } : d));

  const resetKeys = (keys: (keyof PersonalizationData)[]) => setDraft((d) => {
    if (!d || !saved) return d;
    const next = structuredClone(d);
    keys.forEach((k) => { (next as unknown as Record<string, unknown>)[k] = structuredClone((saved as unknown as Record<string, unknown>)[k]); });
    return next;
  });
  // Scoped discard for the taxonomy sections: reverts the list + only THAT section's override field,
  // so discarding Caller types never touches an unsaved Categories override edit (and vice-versa).
  const discardTaxonomy = (list: 'callerTypes' | 'categories', ov: keyof Overrides) => setDraft((d) => {
    if (!d || !saved) return d;
    return { ...d, [list]: structuredClone(saved[list]), overrides: { ...d.overrides, [ov]: saved.overrides[ov] } };
  });

  return (
    <div className="organization-panel personalization-panel">
      {/* v12.10.8 (#1160): the four Personalization sections - not on the Vocabulary area. */}
      {part === 'personalization' && (<>
      {/* ── 1. Caller types ──────────────────────────────────────────────── */}
      <Section
        title="Caller types" help={CT_HELP}
        description="Who is calling — the caller types of your workflow. Names come from the workflow; here you pick the colour and icon that paint the caller's avatar tile in Messages." 
        dirty={ctDirty} saving={saveCallerTypes.isPending}
        onSave={() => saveCallerTypes.mutate(draft)} onDiscard={() => discardTaxonomy('callerTypes', 'callerType')}>
        <OverrideStrip label="caller type" on={draft.overrides.callerType} onToggle={() => setOverride('callerType', !draft.overrides.callerType)} />
        <table className="pz-table">
          {/* v12.10.17 (#1723 D11): Name / Key / Active / Add / Delete are workflow-owned - colour + icon only here. */}
          <thead><tr><th>Name</th><th>Color</th><th>Icon</th><th /></tr></thead>
          <tbody>
            <LockedRow name="Unclassified" icon="User" iconKind="caller"
              title="System type - shown when the caller type could not be told. Not editable." />
            {sortedView(draft.callerTypes).map(({ item: c, index: i }) => (
              <tr key={i} className={c.active ? '' : 'pz-off'}>
                <td data-label="Name"><span className="pz-name"><span className="pz-swatch" style={{ background: c.color }}><CallerTypeIcon name={c.icon} size={11} className="pz-swatch-ico" /></span>{c.name}</span></td>
                <td data-label="Color"><span className="pz-hex">{c.color.toUpperCase()}</span></td>
                <td data-label="Icon"><span className="pz-icon"><CallerTypeIcon name={c.icon} size={15} /> {iconLabel(c.icon)}</span></td>
                <td className="pz-acts" data-label="">
                  <button type="button" className="icon-btn" onClick={() => guardOpen(() => setCtModal({ index: i, draft: structuredClone(c) }))} aria-label="Edit colour and icon"><EditIcon /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Section>

      {/* ── 2. Categories (internal key "Message categories") ────────────── */}
      <Section
        title="Categories" help={CAT_HELP}
        description="What the caller wants — the intent cards of your workflow. Names come from the workflow; here you pick the colour and icon of the pill on each message and its filter." 
        dirty={catDirty} saving={saveCategories.isPending}
        onSave={() => saveCategories.mutate(draft)} onDiscard={() => discardTaxonomy('categories', 'category')}>
        <OverrideStrip label="category" on={draft.overrides.category} onToggle={() => setOverride('category', !draft.overrides.category)} />
        <table className="pz-table">
          {/* v12.10.17 (#1723 D10 D11): "Uncategorized" is "Unclassified" now; colour + icon only. v12.10.22 (#2011): + Used by. */}
          <thead><tr><th>Name</th><th>Color</th><th>Icon</th><th>Used by</th><th /></tr></thead>
          <tbody>
            <LockedRow name="Unclassified" icon="Help" iconKind="category" extraCells={1}
              title="System category - shown when the request could not be told. Not editable." />
            {sortedView(draft.categories).map(({ item: c, index: i }) => (
              <tr key={i} className={c.active ? '' : 'pz-off'}>
                <td data-label="Name"><span className="pz-name"><span className="pz-swatch" style={{ background: c.color }}><PracticeIcon name={c.icon} size={11} className="pz-swatch-ico" /></span>{c.name}</span></td>
                <td data-label="Color"><span className="pz-hex">{c.color.toUpperCase()}</span></td>
                <td data-label="Icon"><span className="pz-icon"><PracticeIcon name={c.icon} size={15} /> {c.icon}</span></td>
                {/* v12.10.22 (#2011): every workflow › intent filing under this category (an intent can pick another's category on its card) */}
                <td data-label="Used by" className="pz-usedby">{(c.usedBy ?? []).join(' \u00b7 ')}{(c.usedBy?.length ?? 0) > 1 ? ` (${c.usedBy!.length} intents)` : ''}</td>
                <td className="pz-acts" data-label="">
                  <button type="button" className="icon-btn" onClick={() => guardOpen(() => setMcModal({ index: i, draft: structuredClone(c) }))} aria-label="Edit colour and icon"><EditIcon /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Section>

      {/* ── 3. Labels ────────────────────────────────────────────────────── */}
      <Section
        title="Labels" help={LB_HELP}
        description="Custom tags agents apply to organize messages (e.g. Callback Done, Follow-up Required, VIP Patient)."
        addLabel="Add label" onAdd={() => guardOpen(() => setLbModal({ index: null, draft: lbBlank() }))}
        dirty={lbDirty} saving={saveLabels.isPending}
        onSave={() => saveLabels.mutate(draft)} onDiscard={() => resetKeys(['labels'])}>
        <div className="lb-grid">
          {sortedView(draft.labels).map(({ item: l, index: i }) => (
            <div key={i} className="lb-card">
              <span className="lb-dot" style={{ background: l.color }} />
              <span className="lb-name" title={l.name}>{l.name}</span>
              <div className="lb-acts">
                <button type="button" className="icon-btn" onClick={() => guardOpen(() => setLbModal({ index: i, draft: structuredClone(l) }))} aria-label="Edit"><EditIcon /></button>
                <button type="button" className="icon-btn danger" onClick={() => setLabels((list) => list.filter((_, j) => j !== i))} aria-label="Delete"><TrashIcon /></button>
              </div>
            </div>
          ))}
          {draft.labels.length === 0 && <div className="pz-empty">No labels yet.</div>}
        </div>
      </Section>

      {/* ── 4. v12.10.18 (#1864, UI-PROTO-T148 v1.10 LOCKED 10/22): "Messages workspace" - grouping, refresh and Automatic status
            (moved in, Q7) - its own Save; "Repeat callers" (what the CALL does) comes LAST, its own Save. ── */}
      <Section
        title="Messages workspace" help={MW_HELP}
        description="How calls show in Messages - grouping repeat callers, refresh, and the statuses the system sets for you."
        dirty={asDirty} saving={saveGrouping.isPending}
        onSave={() => saveGroupingCard('auto')} onDiscard={() => discardGroupingCard('auto')}>
        <div className="f">
          <label>When the same caller calls back<HelpTooltip sections={GR_MODE_HELP} /></label>
          <div className="seg-group" role="radiogroup" aria-label="When the same caller calls back">
            {([['continue', 'Group with the previous calls'], ['new', 'Separate message']] as [Grouping['sameCaller'], string][]).map(([v, l]) => (
              <button key={v} type="button" role="radio" aria-checked={draft.grouping.sameCaller === v} className={`seg${draft.grouping.sameCaller === v ? ' on' : ''}`} onClick={() => setGrouping({ sameCaller: v })}><span className="seg-dot" />{l}</button>
            ))}
          </div>
        </div>
        {draft.grouping.sameCaller === 'continue' && (
          <div className="f rc-window" style={{ marginTop: 14 }}>
            <label className="rc-inline-label">Grouping window:<HelpTooltip sections={GR_WINDOW_HELP} />
              <RcSwitch on={draft.grouping.sameDay ?? false} onChange={(v) => setGrouping({ sameDay: v })} label="Same day" />
              <span className="rc-sw-lbl">Same day</span>
              <span className={`rc-inline-num${draft.grouping.sameDay ? ' is-off' : ''}`}><NumberField value={draft.grouping.appendWindow} onChange={(v) => setGrouping({ appendWindow: v })} unit="minutes" min={1} max={240} /></span>
              <small className="settings-hint">counted from the caller&rsquo;s latest call</small>
            </label>
            <small className="settings-hint">One card per caller (&times;N times), Combined in the drawer.</small>
          </div>
        )}
        {/* v12.10.16.1 (#1702): the open Messages list re-reads itself this often. */}
        <div className="f rc-window" style={{ marginTop: 14 }}>
          <label className="rc-inline-label">Refresh the Messages list every
            <span className="rc-inline-num"><NumberField value={draft.grouping.refreshSeconds ?? 60} onChange={(v) => setGrouping({ refreshSeconds: v })} unit="seconds" min={10} max={300} /></span>
          </label>
          <small className="settings-hint">How often an open Messages screen checks for new calls. Lower = sooner; higher = less load on a busy practice. Default 30.</small>
        </div>
        <div className="f" style={{ marginTop: 18 }}>
          <label>Automatic status<HelpTooltip sections={AS_HELP} /></label>
          <div className="rc-switch-row">
            <RcSwitch on={draft.grouping.autoComplete ?? false} onChange={(v) => setGrouping({ autoComplete: v })} label="Mark missed calls with no details complete automatically" />
            <div><b>Mark missed calls with no details complete automatically</b>
              <small className="settings-hint">The caller said nothing, left no voicemail and nothing was captured (for example, hung up during the greeting). Still listed under Completed and inside its caller&rsquo;s group.</small></div>
          </div>
          <div className="rc-switch-row is-parked">
            <RcSwitch on={false} onChange={() => {}} label="Mark urgent automatically" disabled />
            <div><b>Mark urgent automatically when &hellip;</b><small className="settings-hint">Conditions to define (parked).</small></div>
          </div>
        </div>
        {/* ══ v12.10.19 (#1924 #1925, LOCKED 10/23 - WHAT-THE-CALLER-NEEDS v1.3 section 8): how Wants + Next step are written. ══ */}
        <div className="f" style={{ marginTop: 18 }}>
          <label>What the caller needs</label>
          <small className="settings-hint">How the Wants line and the Next step on each message are written. AI reads the call with names, date of birth, phone, address, ZIP, member ID and email removed before it is sent; a number in its answer that is not in the record or the call falls back to Local.</small>
          <div className="rc-inline-label" style={{ marginTop: 10 }}><b style={{ minWidth: 110 }}>Live calls</b>
            <div className="seg-group" role="radiogroup" aria-label="Live calls">
              {([['local', 'Local'], ['ai', 'AI']] as const).map(([v, l]) => (
                <button key={v} type="button" role="radio" aria-checked={(draft.grouping.needsLive ?? 'local') === v} className={`seg${(draft.grouping.needsLive ?? 'local') === v ? ' on' : ''}`}
                  onClick={() => setGrouping({ needsLive: v })}><span className="seg-dot" />{l}{v === 'local' && <span className="rq-defbadge" style={{ marginLeft: 6 }}>Template default</span>}</button>
              ))}
            </div>
          </div>
          <small className="settings-hint">Local = what Classify decided + the Request card&rsquo;s answers; Next step from the request type&rsquo;s own line on the Request card.</small>
          <div className="rc-inline-label" style={{ marginTop: 10 }}><b style={{ minWidth: 110 }}>Voicemails</b>
            <div className="seg-group" role="radiogroup" aria-label="Voicemails">
              {([['ai', 'AI processing'], ['spoken', 'As spoken'], ['local', 'Local']] as const).map(([v, l]) => (
                <button key={v} type="button" role="radio" aria-checked={(draft.grouping.needsVoicemail ?? 'local') === v} className={`seg${(draft.grouping.needsVoicemail ?? 'local') === v ? ' on' : ''}`}
                  onClick={() => setGrouping({ needsVoicemail: v })}><span className="seg-dot" />{l}{v === 'local' && <span className="rq-defbadge" style={{ marginLeft: 6 }}>Template default</span>}</button>
              ))}
            </div>
            {(draft.grouping.needsVoicemail ?? 'local') === 'spoken' && (
              <span className="rc-inline-num">first <NumberField value={draft.grouping.needsSpokenWords ?? 25} onChange={(v) => setGrouping({ needsSpokenWords: v })} unit="words" min={5} max={80} /></span>
            )}
          </div>
          <small className="settings-hint">As spoken = the caller&rsquo;s own first words. Local = the request from one clear keyword + the dates read from the voicemail.</small>
          <div className="rc-inline-label" style={{ marginTop: 10 }}>Caller confirmation <b>required</b> from
            <span className="rc-inline-num"><NumberField value={draft.grouping.confirmRequiredAt ?? 3} onChange={(v) => setGrouping({ confirmRequiredAt: v })} unit="flagged fields" min={2} max={10} /></span>
          </div>
          <small className="settings-hint">Fewer flagged fields add &ldquo;Caller confirmation advised&rdquo; to the Next step. Template default 3.</small>
        </div>
      </Section>

      <Section
        title="Repeat callers" help={GR_HELP}
        description="What happens on the call when the same number calls again soon after."
        dirty={grDirty} saving={saveGrouping.isPending}
        onSave={() => saveGroupingCard('repeat')} onDiscard={() => discardGroupingCard('repeat')}>
        <div className="f">
          <label className="rc-inline-label">On the call - when the same number calls again within
            <span className="rc-inline-num"><NumberField value={draft.grouping.onCallWindow ?? 10} onChange={(v) => setGrouping({ onCallWindow: v })} unit="min" min={1} max={120} /></span>
            <HelpTooltip sections={RC_ONCALL_HELP} /></label>
          <div className="seg-group" role="radiogroup" aria-label="On the call">
            {([['off', 'Off'], ['greeting', 'Continue where left off'], ['voicemail', 'Straight to voicemail']] as ['off' | 'greeting' | 'voicemail', string][]).map(([v, l]) => (
              <button key={v} type="button" role="radio" aria-checked={(draft.grouping.onCall ?? 'off') === v} className={`seg${(draft.grouping.onCall ?? 'off') === v ? ' on' : ''}`} onClick={() => setGrouping({ onCall: v })}><span className="seg-dot" />{l}</button>
            ))}
          </div>
          <small className="settings-hint">
            {(draft.grouping.onCall ?? 'off') === 'off' ? 'Every call starts from the beginning.'
              : draft.grouping.classic
                ? ((draft.grouping.onCall ?? 'off') === 'voicemail' ? 'Goes straight to the workflow’s voicemail greeting - not the Send to voicemail card’s own line. (Today’s text.)'
                  : 'No recording notice again; the Greeting card answers, and what the last call collected (the patient, the callback number) is carried forward - not asked again. (Today’s text.)')
                : ((draft.grouping.onCall ?? 'off') === 'voicemail' ? 'The caller goes straight to voicemail; if they already left a message, they are told it was received.'
                  : 'The AI picks up from the last call and asks only what is still missing.')}
          </small>
          {(draft.grouping.onCall ?? 'off') !== 'off' && (
            <div className="rc-switch-row rc-mode-row">
              <span className="rc-mode-k">Mode</span>
              <RcSwitch on={draft.grouping.classic ?? false} onChange={(v) => setGrouping({ classic: v })} label="Classic" />
              <div><b>Classic</b><small className="settings-hint">{draft.grouping.classic
                ? 'On: works exactly as before - no new lines are spoken, so they are hidden. Switch back any time, no deploy.'
                : 'Off by default: the new behavior below. Turn on to work exactly as before - the lines below are hidden. Switch back any time, no deploy.'}</small></div>
            </div>
          )}
        </div>
        {(draft.grouping.onCall ?? 'off') !== 'off' && !draft.grouping.classic && (
          <RepeatLinesEditor mode={draft.grouping.onCall === 'voicemail' ? 'voicemail' : 'continue'} lines={draft.grouping.lines ?? {}}
            onChange={(lines) => setGrouping({ lines })} routes={draft.grouping.routes ?? {}} onRoutes={(routes) => setGrouping({ routes })} />
        )}
        {/* v12.10.26 (#2128): the safeguard's short-reply list - calls AND text replies, whatever the mode above. */}
        <NoDetailsRepliesEditor value={draft.grouping.noDetailsReplies ?? {}} onChange={(noDetailsReplies) => setGrouping({ noDetailsReplies })} />
      </Section>

      </>)}

      {/* ── 5. Vocabulary › Fields (v12.10.8 #1160: its own Settings area) ── */}
      {part !== 'vocabulary' ? null : vocabError ? (
        <section className="settings-section-card">
          <header className="settings-section-header"><div className="settings-section-headrow"><h2>Fields<HelpTooltip sections={VOCAB_HELP} /></h2></div></header>
          <div className="pz-section-body"><div className="settings-error">Vocabulary could not be loaded.</div></div>
        </section>
      ) : !(vocabDraft && vocabSaved) ? (
        <section className="settings-section-card">
          <header className="settings-section-header"><div className="settings-section-headrow"><h2>Fields<HelpTooltip sections={VOCAB_HELP} /></h2></div></header>
          <div className="pz-section-body"><div className="settings-loading">Loading fields…</div></div>
        </section>
      ) : (
        <Section
          title="Fields" help={VOCAB_HELP}
          description="The people and things a call is about, in your words. Your label shows everywhere; the term never changes, so workflows keep working."
          dirty={vocabDirty} saving={saveVocabulary.isPending}
          onSave={() => { if (vocabDraft) saveVocabulary.mutate(vocabDraft); }}
          onDiscard={() => setVocabDraft(vocabSaved ? { ...vocabSaved } : vocabDraft)}>
          {/* v12.10.8.1 (#1230 #1233, UI-PROTO-VOCAB-1229-1230 v1.6 APPROVED): the add button at the TOP, ruled off from
              the list; it creates a TERM of the practice's own (fields come after, with the term's + Add field). */}
          <div className="vocab-toprow">
            <button type="button" className="vocab-addfield" onClick={() => openTerm(null)}>+ Add new vocabulary</button>
            <span className="settings-hint">Create a term of your own - Medication, Insurance, Pharmacy - then add its fields. A term a workflow step stores under also appears here.</span>
          </div>
          <p className="vocab-intro">Every system and custom field, grouped by the vocabulary term it belongs to. Click a field to edit it, or use <b>+ Add field</b> to add a custom field to that term.</p>
          <table className="pz-table vocab-table">
            <thead><tr><th>What it is</th><th>Term</th><th>Your label</th></tr></thead>
            <tbody>
              {vocabEntities.map((e) => (
                <tr key={e.token}>
                  <td data-label="What it is">
                    <span className="vocab-what">{e.what}</span>
                    <small className="vocab-sub">{e.sub}</small>
                    {/* ── v12.7.0 (#576): EVERY FIELD OPENS - IN THE DRAWER. ──────────────────────────
                        Tushar, 2026-09-21, with arrows on lastName, dob, address2 and zip: "i just checked
                        vocabulary and still did not see the hyperlink". It was never built and I never logged
                        it. 12.6.2 made the fields open an INLINE CARD, which he caught on verification -
                        "wasn't it supposed to open drawer?" - and he was right: #499's rule is that this
                        concept has ONE component, and quietly making a second one is how #428/#429/#437/#439
                        happened. The drawer now has a read-only mode and platform fields open it.

                        It matters because since #563 the Type is what the engine validates a live answer
                        against, and since #569 it decides whether a caller is re-asked at all. */}
                    <small className="vocab-fields"><span className="vocab-cap">Fields:</span>{' '}
                      {(e.fieldList ?? e.fields.split('·').map((k) => ({ key: k.trim() } as VocabField)))
                        .filter((f) => f.key)
                        .map((f) => (
                          <button
                            key={f.key}
                            type="button"
                            className={`vocab-field-chip${(vocabData?.fieldOverrides ?? {})[`${e.token}.${f.key}`]?.isOn === false ? ' is-off' : ''}`}
                            title={`${e.token}.${f.key}${f.type ? ` \u00b7 ${f.type}` : ''}${(vocabData?.fieldOverrides ?? {})[`${e.token}.${f.key}`]?.isOn === false ? ' \u00b7 Off - hidden from screens' : ''}`}
                            onClick={() => guardOpen(() => openPlatformField(e.token, f))}>
                            {f.key}
                          </button>
                        ))}
                    </small>
                    {/* v12.4.16 (#499): THE PRIMARY PATH. `subject` stays a platform entity and a practice hangs
                        one more field off it - subject.accountNumber - without waiting for a build. The built-in
                        fields above cannot be renamed away or deleted (BDR-001 v1.2 §7.6); these can. */}
                    {/* v12.10.8.1 (#1229): the practice's own fields are a teal "Custom:" chip line under "Fields:" -
                        no boxed rows; a chip opens the drawer (edit, On / Off, delete inside it). */}
                    <TenantFields
                      entity={e.token}
                      fields={tenantFieldsByEntity.get(e.token.toLowerCase()) ?? []}
                      onAdd={() => guardOpen(() => openAddField(e.token))}
                      onEdit={(f) => guardOpen(() => openEditField(e.token, f))}
                      onRemove={(f) => setRemoveField({ token: f.key })}
                      asChips
                    />
                  </td>
                  <td data-label="Term"><TermBox token={e.token} /></td>
                  <td data-label="Your label">
                    <input className="vocab-lbl" value={vocabDraft[e.token] ?? ''} placeholder={e.fallback}
                      onChange={(ev) => setVocabDraft((m) => ({ ...(m ?? {}), [e.token]: ev.target.value }))} />
                  </td>
                </tr>
              ))}
              {/* v12.3.12 (#314): the tenant's OWN registered fields - one line each, token plus the fields
                  available under it, no description, exactly as Tushar asked. The label renames the entity the
                  same way the platform rows do, so {'{medication.pharmacy}'} can read as "Drug > Pharmacy". */}
              {customEntities.map((e) => (
                <tr key={`custom-${e.token}`} className="vocab-custom-row">
                  <td data-label="What it is">
                    {/* ── v12.7.2 (#614): THE SIXTH REPORT, AND THE FIRST TIME IT HAS BEEN AN ITEM. ──────────
                        Tushar, 2026-09-22: "this is sixth time i am reporting - Your field should also have the
                        look of what the other system said displaying labels as Medication then fields like
                        daysofsupply . form . name . pharmacyname . all with hyperlink as the system fields so
                        the layout looks polished and universal. instead of showing Your field - Your Own Entity
                        - we can display something like Custom - Medication".

                        It had never been logged. Each time he raised it the screen was open for something else
                        - #314 built this row, #499 gave it per-field controls, #576 gave the PLATFORM rows
                        their chips - and the parity ask was absorbed and then not built. The two halves of
                        this table stopped matching in 12.7.0, which is exactly when #576 landed.

                        "Custom - {label}" rather than "Your field": BDR-001's split, where the token is the
                        key and the label is the tenant's own word. */}
                    <span className="vocab-what vocab-tname">Custom<span className="vocab-yours">{(vocabDraft[e.token] || '').trim() || e.token}</span>
                      {/* v12.10.8.1 (#1230): Edit · Delete next to the term's name (Remove left the label column). */}
                      <button type="button" className="vocab-tact" onClick={() => openTerm(e.token)}>Edit</button>
                      <button type="button" className="vocab-tact del" onClick={() => setRemoveField({ token: e.token })}>Delete</button>
                    </span>
                    {e.what ? <small className="vocab-sub">{e.what}</small> : null}
                    <TenantFields
                      entity={e.token}
                      fields={tenantFieldsByEntity.get(e.token.toLowerCase()) ?? []}
                      onAdd={() => guardOpen(() => openAddField(e.token))}
                      onEdit={(f) => guardOpen(() => openEditField(e.token, f))}
                      onRemove={(f) => setRemoveField({ token: f.key })}
                      /* v12.7.2 (#614): chips, like the platform rows. His decision on what a chip DOES:
                         "yes, clicking on chip will open the same drawer with editable." So the vertical
                         list collapses behind them - one component per concept (#499), because two ways to
                         edit one field is how #428 / #429 / #437 / #439 happened. */
                      asChips
                    />
                  </td>
                  <td data-label="Term"><TermBox token={e.token} /></td>
                  <td data-label="Your label">
                    <input className="vocab-lbl" value={vocabDraft[e.token] ?? ''} placeholder={e.token}
                      onChange={(ev) => setVocabDraft((m) => ({ ...(m ?? {}), [e.token]: ev.target.value }))} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {/* v12.10.8.1 (#1233): the bottom "+ Add vocabulary" (which could only pick an EXISTING term) moved to the top as "+ Add new vocabulary" and now creates a term. */}
        </Section>
      )}

      {/* v12.4.16 (#499): the field drawer - see components/vocabulary/ (v12.10.8: Identity extraction no longer opens it). */}
      <VocabularyFieldDrawer
        mode="vocabulary"
        draft={fieldDraft}
        editing={fieldEditing != null}
        entities={drawerEntities}
        lists={drawerLists}
        keyError={fieldReadOnly ? undefined : fieldKeyError}
        saving={saveField.isPending || savePlatformField.isPending}
        readOnly={fieldReadOnly}
        datePurposes={vocabData?.datePurposes ?? []}
        dateOrder={vocabData?.dateOrder}
        onChange={fieldSet}
        onClose={() => { setFieldDraft(null); setFieldEditing(null); setFieldReadOnly(false); }}
        onSave={() => {
          if (!fieldDraft) return;
          // v12.8.0 (#659): a platform field goes to field-overrides, a tenant field to custom-fields.
          if (fieldReadOnly) { savePlatformField.mutate(fieldDraft); return; }
          if (!fieldKeyError) saveField.mutate(fieldDraft);
        }}
      />

      {/* v12.3.12 (#314 + #323): unregistering goes through the SHARED delete gate, not a bespoke dialog -
          that is the whole point of making it a standard. */}
      {termDraft && (
        <Drawer
          title={termDraft.editing ? `Edit - ${termDraft.term}` : 'Add new vocabulary'}
          subtitle={termDraft.editing ? 'Settings for the term itself. Its fields are edited from their chips.' : 'Adds the term only. Then use its + Add field to define each field with all its settings.'}
          saveLabel={termDraft.editing ? 'Done' : 'Add'}
          canSave={!!termDraft.term.trim() && !termError && !saveTerm.isPending}
          onClose={() => setTermDraft(null)}
          onSave={() => saveTerm.mutate(termDraft)}>
          <div className="vocab-term-two">
            <div className="f"><label>Term</label>
              {termDraft.editing
                ? <TermBox token={termDraft.term} />
                : <input value={termDraft.term} placeholder="insurance" autoFocus
                    onChange={(ev) => { const term = ev.target.value.toLowerCase().replace(/[^a-z0-9]/g, ''); setTermDraft((d) => d && ({ ...d, term, label: d.label && d.label !== cap(d.term) ? d.label : cap(term) })); }} />}
            </div>
            <div className="f"><label>Your label</label>
              <input value={termDraft.label} placeholder="Insurance" onChange={(ev) => setTermDraft((d) => d && ({ ...d, label: ev.target.value }))} /></div>
          </div>
          {termError ? <span className="mrow-hint aa-hint-err">{termError}</span> : null}
          <div className="f"><label>What it is <span className="mrow-hint" style={{ marginLeft: 6 }}>(optional)</span></label>
            <input value={termDraft.what} placeholder="The caller's insurance plan" onChange={(ev) => setTermDraft((d) => d && ({ ...d, what: ev.target.value }))} /></div>
          {!termDraft.editing && termDraft.term.trim() && !termError
            ? <div className="vocab-term-tok">Its fields will be {'{'}{termDraft.term.trim()}.<i>field</i>{'}'}</div> : null}
          <span className="mrow-hint">{termDraft.editing
            ? 'The term is locked once saved - workflows store under it.'
            : 'Term: lowercase letters; it cannot match a built-in term (caller, subject ...). Your label is filled in from it and can be changed.'}</span>
        </Drawer>
      )}

      {removeField && (
        <ConfirmDelete
          what={removeField.token.includes('.') ? 'field' : 'term'}
          name={removeField.token}
          consequence={removeField.token.includes('.')
            ? 'it stops being offered by the token pickers, and any integration reading it will stop finding it. Workflow steps that capture it are not changed, and calls that already stored a value keep it.'
            : 'the term and all its fields stop being offered by the token pickers. Check first that no workflow step or integration still stores under it - steps are not changed, and calls that already stored values keep them.'}
          busy={removeCustom.isPending}
          onCancel={() => setRemoveField(null)}
          onConfirm={() => removeCustom.mutate(removeField.token)}
          confirmLabel="Remove"
        />
      )}

      {/* ── 6. Agent phrases (#254) - REMOVED in v12.9.26 (#969): every line the agent speaks is now in Workflow >
          lane 7 'Phrases', in every language the organization runs, editing the SAME stored agentPhrases values. */}
      {/* ── 7. Lists (#500 / #501) ────────────────────
          Tushar, 2026-09-19: "Lists and lists can have list like Provider, Locations, etc.." The SECTION is
          Lists; the things inside it are lists a tenant creates. A salon's would be Stylists and Chairs and
          the platform does not need to know the difference - which is why this is not called "Booking".

          WHAT THIS SCREEN DOES TODAY, STATED PLAINLY BECAUSE HALF-WIRED IS WORSE THAN SMALL:
            * It DEFINES the values: id, name, description, aliases, spoken form, active flag, and an external
              id PER INTEGRATION.
            * It IMPORTS them from a pasted CSV / TSV / JSON (#501), updating matched rows by internal id
              rather than duplicating them.
          WHAT IT DOES NOT DO YET, and nothing on this screen implies otherwise: the CALL ENGINE does not yet
          read these lists. A caller's answer is not validated against a list, and the external id is not
          substituted at send time. That is the engine hookup, and it is deliberately not faked here - a screen
          that LOOKS like it validates and does not is the failure this project keeps paying for. */}
      {/* ══ v12.10.10 (#1406 / #1407, UI-PROTO-T47-LIST-DRAWERS v1.0 + LIST-ENTRY v1.1): LISTS ════════════════════════════
          Every change here SAVES AT ONCE - the list drawer, the entry drawer, On / Off, Active, Import. Drawer work never
          sits in the unsaved bar (Tushar 10/8). A list has a permanent internal id; its name and what it is for edit freely
          because fields tie to the id. A field tied to a list is matched, offered ({lists.entity.field}) and sent per system. */}
      {part === 'vocabulary' && !vocabError && listsDraft && listsSaved && (
        <Section
          title="Lists" help={LISTS_HELP} noSave
          description={'The values a field can hold - Providers, Locations, Visit types. Tie a field to a list (Vocabulary › Fields) and the AI matches what the caller says to it, offers the entries when a prompt uses {lists.entity.field}, and sends each connected system its own value. Deactivate an entry rather than deleting it: calls already taken point at it.'}
          dirty={false} saving={saveLists.isPending}
          onSave={() => undefined} onDiscard={() => undefined}>

          <div className="vocab-toprow">
            <button type="button" className="vocab-addfield" onClick={() => guardOpen(() => setListDrawer({ key: null, name: '', description: '', isOn: true, offerCap: 3 }))}>+ Add new list</button>
            <span className="settings-hint">Create a list of values a field can hold - your providers, locations or visit types.</span>
          </div>
          {Object.keys(listsDraft).length === 0 && (
            <p className="settings-hint">No lists yet. Create one for anything a caller picks from &mdash; your providers, your locations, the kinds of visit you offer.</p>
          )}

          {Object.values(listsDraft).sort((a, b) => a.name.localeCompare(b.name)).map((L) => {
            const tied = tiedFieldsOf(L.key);
            // v12.10.26 (#2141 T193 Q1 a): a list filled from another page (Locations <- Organization › Locations) is read-only here -
            // values are added, renamed and removed there; its tie to a field works as today.
            const managedBy = vocabData?.managedLists?.[L.key];
            const active = L.entries.filter((e) => e.active).length;
            const cap = L.offerCap ?? 4;
            return (
            <div key={L.key} className="lst-card">
              <div className="lst-head">
                <button type="button" className="lst-toggle" aria-expanded={openList === L.key}
                  onClick={() => setOpenList(openList === L.key ? null : L.key)}>
                  {openList === L.key ? '▾' : '▸'} {L.name}
                </button>
                <span className="lst-count">{L.entries.length} {L.entries.length === 1 ? 'entry' : 'entries'}
                  {L.entries.some((e) => !e.active) ? ` · ${L.entries.filter((e) => !e.active).length} inactive` : ''}</span>
                {/* C8: how many of the Active entries an offer reads out */}
                <span className="lst-offer">{cap === 0 ? 'never offered' : active > cap ? `${cap} of ${active} will be offered` : `all ${active} offered`}</span>
                <span className="lst-spacer" />
                {managedBy && <span className="pz-lock-badge" title={`Values are added, renamed and removed in ${managedBy}`}><LockIcon /> read-only · filled from <Link to="/configuration/organization">{managedBy}</Link></span>}
                {/* v12.10.8 (#1227): Off hides this list from list pickers - a field already tied to it keeps working. */}
                {!managedBy && <>
                <button type="button" className={`qa-chip${L.isOn === false ? ' off' : ''}`} aria-pressed={L.isOn !== false}
                  title={L.isOn === false ? 'Off - not offered in list pickers. Click to switch on.' : 'On - offered in list pickers. Click to switch off (nothing stops working).'}
                  onClick={() => commitLists(patchList(listsDraft, L.key, { isOn: L.isOn === false })!)}>{L.isOn === false ? 'Off' : 'On'}</button>
                <button type="button" className="vocab-sm" onClick={() => guardOpen(() => setListDrawer({ key: L.key, name: L.name, description: L.description, isOn: L.isOn !== false, offerCap: L.offerCap ?? 4 }))}>Edit list</button>
                <button type="button" className="vocab-sm" onClick={() => guardOpen(() => setImportFor(L.key))}>Import&hellip;</button>
                </>}
              </div>
              <div className="lst-tied">{tied.length
                ? <>Tied to: {tied.map((t) => <code key={t} className="lst-tiechip">{`{${t}}`}</code>)}</>
                : <span className="settings-hint">Not tied to a field yet - tie one in Vocabulary › Fields.</span>}</div>

              {openList === L.key && (
                <div className="lst-body">
                  {L.description && <p className="settings-hint">{L.description}</p>}
                  <table className="pz-table lst-table">
                    <thead><tr><th>Name</th><th>Caller might say</th><th>AI says back</th><th>Connected system IDs</th><th className="ta-r"></th></tr></thead>
                    <tbody>
                      {L.entries.map((en) => {
                        const rows = en.systems ?? Object.entries(en.externalIds).map(([system, theirId]) => ({ system, valueFrom: 'typed' as const, value: '', theirId }));
                        const missing = systemNames.filter((n) => !rows.some((r) => r.system.toLowerCase() === n.toLowerCase()));   // C5
                        return (
                        <tr key={en.id} className={en.active ? '' : 'pz-off'}>
                          <td data-label="Name">
                            <span className="pz-name">{en.name}</span>
                            {en.description ? <small className="vocab-sub">{en.description}</small> : null}
                          </td>
                          <td data-label="Caller might say"><span className="id-val">{en.aliases.length ? en.aliases.join(' · ') : '—'}</span></td>
                          <td data-label="AI says back"><span className="id-val">{en.spoken || en.name}</span></td>
                          <td data-label="Connected systems">
                            {rows.length === 0 && missing.length === 0 ? <span className="id-val">&mdash;</span> : null}
                            {rows.map((r) => <span key={r.system} className="id-val lst-sysline">{r.system}: {r.valueFrom === 'typed' ? (r.value || en.name) : `(${r.valueFrom})`}{r.theirId ? ` · id ${r.theirId}` : ''}</span>)}
                            {missing.map((n) => <span key={n} className="lst-gap" title="This connected system has no value / id for this entry - a body that sends it gets the Name and an empty id">no {n} value / id</span>)}
                          </td>
                          <td className="pz-acts">
                            {managedBy ? <span className="pz-lock-badge"><LockIcon /> {managedBy}</span> : <>
                            <button type="button" className={`qa-chip${en.active ? '' : ' off'}`}
                              title={en.active ? 'Deactivate - it stops being offered, and calls that already used it keep resolving' : 'Reactivate'}
                              onClick={() => commitLists(patchEntry(listsDraft, L.key, en.id, { active: !en.active })!)}>
                              {en.active ? 'Active' : 'Inactive'}
                            </button>
                            <button type="button" className="icon-btn" aria-label="Edit"
                              onClick={() => guardOpen(() => setEntryDraft(entryDraftFor(L.key, en, false, orgLangs)))}><EditIcon /></button>
                            </>}
                          </td>
                        </tr>
                        );
                      })}
                      {L.entries.length === 0 && <tr><td colSpan={5}><div className="aa-empty">Nothing in this list yet. Add an entry, or import a file.</div></td></tr>}
                    </tbody>
                  </table>
                  {/* No delete on an entry, by design: a historical call points at its id. Deactivate instead. */}
                  {managedBy
                    ? <p className="settings-hint">Values are added, renamed and removed in <Link to="/configuration/organization">{managedBy}</Link>. Nothing to type here.</p>
                    : <button type="button" className="vocab-addfield" onClick={() => guardOpen(() => setEntryDraft(entryDraftFor(L.key, blankEntry(), true, orgLangs)))}>+ Add entry</button>}
                </div>
              )}
            </div>
            );
          })}
        </Section>
      )}

      {/* v12.10.10 (#1406, UI-PROTO-T47-LIST-DRAWERS v1.0 #1 / #2): New list / Edit list. Saves on Save list. */}
      {listDrawer && listsDraft && (() => {
        const ld = listDrawer;
        const nameTaken = Object.values(listsDraft).some((l) => l.key !== ld.key && l.name.trim().toLowerCase() === ld.name.trim().toLowerCase());
        const entries = ld.key ? listsDraft[ld.key]?.entries ?? [] : [];
        const active = entries.filter((e) => e.active).length;
        const tied = ld.key ? tiedFieldsOf(ld.key) : [];
        return (
          <Drawer
            title={ld.key ? 'Edit list' : 'New list'}
            subtitle={ld.key ? `${ld.name || 'List'} · ${entries.length} ${entries.length === 1 ? 'entry' : 'entries'}` : 'A list of values a field can hold - providers, locations, visit types.'}
            saveLabel="Save list"
            canSave={!!ld.name.trim() && !nameTaken}
            danger={ld.key ? { label: 'Remove list', onClick: () => { setRemoveList(ld.key); setListDrawer(null); } } : undefined}
            onClose={() => setListDrawer(null)}
            onSave={() => {
              const key = ld.key ?? newListId(Object.keys(listsDraft));
              const prev = listsDraft[key];
              const next = { ...listsDraft, [key]: { ...(prev ?? { key, entries: [] }), key, name: ld.name.trim(), description: ld.description.trim(), isOn: ld.isOn, offerCap: Math.max(0, Math.min(20, Math.round(ld.offerCap))) } };
              commitLists(next);
              setListDrawer(null);
              if (!ld.key) setOpenList(key);
            }}>
            <div className="fr">
              <div className="f"><label>Name</label>
                <input value={ld.name} onChange={(ev) => setListDrawer({ ...ld, name: ev.target.value })} />
                <span className="settings-hint">{nameTaken ? <b className="pz-err">Another list already has this name.</b> : 'Must be unique. You can rename it any time.'}</span></div>
              <div className="f"><label>Status</label>
                <select value={ld.isOn ? 'on' : 'off'} onChange={(ev) => setListDrawer({ ...ld, isOn: ev.target.value === 'on' })}>
                  <option value="on">On</option><option value="off">Off</option>
                </select></div>
            </div>
            <div className="f"><label>What it is for</label>
              <input value={ld.description} onChange={(ev) => setListDrawer({ ...ld, description: ev.target.value })} /></div>
            <div className="f"><label>Offer up to</label>
              <input type="number" min={0} max={20} value={ld.offerCap} onChange={(ev) => setListDrawer({ ...ld, offerCap: Number(ev.target.value) || 0 })} style={{ maxWidth: 120 }} />
              <span className="settings-hint">How many Active entries the AI reads out when a prompt offers this list. 0 = never offered.
                {ld.key ? (ld.offerCap === 0 ? ' Nothing will be offered.' : active > ld.offerCap ? ` ${ld.offerCap} of ${active} Active entries will be offered (top of the list).` : ` ${active} Active ${active === 1 ? 'entry' : 'entries'} - all will be offered.`) : ''}</span></div>
            {ld.key && (
              <div className="f"><label>Tied to</label>
                <div>{tied.length ? tied.map((t) => <code key={t} className="lst-tiechip">{`{${t}} · ${tiedColumnWord(t)}`}</code>) : <span className="settings-hint">No field yet.</span>}</div>
                <span className="settings-hint">Change a tie in Vocabulary › Fields. Renaming this list never breaks these - they point at the list&rsquo;s internal id.</span></div>
            )}
            {!ld.key && <p className="settings-hint">Entries are added after the list is saved: <b>+ Add entry</b> on the list opens the entry drawer.</p>}
            {ld.key && <p className="settings-hint">Internal id <code>{ld.key}</code> - never changes.</p>}
          </Drawer>
        );
      })()}

      {/* v12.10.10 (#1406, UI-PROTO-T47-LIST-ENTRY v1.1): one entry. Saves on Save. */}
      {entryDraft && listsDraft && (() => {
        const ed = entryDraft;
        const primary = orgLangs[0] ?? 'en';
        const isPrimary = ed.lang === primary;
        const setE = (patch: Partial<ListEntry>) => setEntryDraft((d) => (d ? { ...d, entry: { ...d.entry, ...patch } } : d));
        const spokenOf = (lng: string) => (lng === primary ? ed.entry.spoken : ed.entry.spokenByLang?.[lng] ?? '');
        const setSpoken = (lng: string, v: string, auto = false) => setEntryDraft((d) => {
          if (!d) return d;
          const entry = lng === primary ? { ...d.entry, spoken: v } : { ...d.entry, spokenByLang: { ...(d.entry.spokenByLang ?? {}), [lng]: v } };
          return { ...d, entry, auto: { ...d.auto, [`spoken:${lng}`]: auto } };
        });
        const setAliasText = (lng: string, v: string, auto = false) => setEntryDraft((d) => (d ? { ...d, aliasText: { ...d.aliasText, [lng]: v }, auto: { ...d.auto, [`alias:${lng}`]: auto } } : d));
        // C10: English typed -> every other language filled at once (auto-translated, marked, editable). Never over a person's words.
        const fillOthers = async (field: 'alias' | 'spoken') => {
          const src = field === 'alias' ? (ed.aliasText[primary] ?? '') : ed.entry.spoken;
          if (!src.trim()) return;
          for (const lng of orgLangs.filter((l) => l !== primary)) {
            const cur = field === 'alias' ? (entryDraft?.aliasText[lng] ?? '') : spokenOf(lng);
            if (cur.trim() && !ed.auto[`${field}:${lng}`]) continue;
            try {
              const res = await api.post<{ ok?: boolean; translated?: string | null }>('/t2/workflow/translate', { text: src, sourceLang: primary, targetLang: lng });
              if (res.ok && res.translated) { if (field === 'alias') setAliasText(lng, res.translated, true); else setSpoken(lng, res.translated, true); }
            } catch { /* no AI key - the box stays empty and can be typed */ }
          }
        };
        const systems = ed.entry.systems ?? [];
        const setSystems = (next: EntrySystem[]) => setE({ systems: next });
        return (
          <Drawer
            title={ed.isNew ? 'Add entry' : 'Edit entry'}
            subtitle="What you call it, what a caller might call it, what the AI says back, and what each connected system gets."
            saveLabel="Save"
            canSave={!!ed.entry.name.trim()}
            onClose={() => setEntryDraft(null)}
            onSave={() => {
              const entry = entryFromDraft(ed, primary);
              const list = listsDraft[ed.list];
              if (!list) { setEntryDraft(null); return; }
              const entries = ed.isNew ? [...list.entries, entry] : list.entries.map((x) => (x.id === entry.id ? entry : x));
              commitLists({ ...listsDraft, [ed.list]: { ...list, entries } });
              setEntryDraft(null);
            }}>
            <div className="fr">
              <div className="f"><label>Name</label>
                <input value={ed.entry.name} onChange={(ev) => setE({ name: ev.target.value })} />
                <span className="settings-hint">What it is called on screen.</span></div>
              <div className="f"><label>Status</label>
                <select value={ed.entry.active ? 'active' : 'inactive'} onChange={(ev) => setE({ active: ev.target.value === 'active' })}>
                  <option value="active">Active &mdash; offered on calls</option>
                  <option value="inactive">Inactive</option>
                </select></div>
            </div>
            <div className="f"><label>Description</label>
              <input value={ed.entry.description} onChange={(ev) => setE({ description: ev.target.value })} />
              <span className="settings-hint">Can be tied to a field (e.g. the provider&rsquo;s role) - otherwise it tells two similar entries apart.</span></div>
            <div className="fr">
              <div className="f"><label>Custom field 1</label><input value={ed.entry.custom1 ?? ''} onChange={(ev) => setE({ custom1: ev.target.value })} /></div>
              <div className="f"><label>Custom field 2</label><input value={ed.entry.custom2 ?? ''} onChange={(ev) => setE({ custom2: ev.target.value })} /></div>
            </div>
            <div className="lst-langbox">
              <div className="lst-langbox-h">What callers say and hear</div>
              <div className="pz-lrail" role="tablist" aria-label="Language">
                {orgLangs.map((l) => (
                  <button key={l} type="button" role="tab" aria-selected={l === ed.lang} className={`pz-ltab${l === ed.lang ? ' sel' : ''}`}
                    onClick={() => setEntryDraft((d) => (d ? { ...d, lang: l } : d))}>{langWord(l)} &middot; {l.toUpperCase()}</button>
                ))}
              </div>
              <div className="f"><label>Caller might say {!isPrimary && ed.auto[`alias:${ed.lang}`] && <span className="lst-auto">auto-translated &middot; edit to correct</span>}</label>
                <input value={ed.aliasText[ed.lang] ?? ''}
                  onChange={(ev) => setAliasText(ed.lang, ev.target.value)}
                  onBlur={() => { if (isPrimary) void fillOthers('alias'); }} />
                <span className="settings-hint">{isPrimary ? 'Comma-separated. For matching what was heard.' : 'Filled from the primary language the moment you type it. Names are never translated.'}</span></div>
              <div className="f"><label>AI says back {!isPrimary && ed.auto[`spoken:${ed.lang}`] && <span className="lst-auto">auto-translated &middot; edit to correct</span>}</label>
                <input value={spokenOf(ed.lang)}
                  onChange={(ev) => setSpoken(ed.lang, ev.target.value)}
                  onBlur={() => { if (isPrimary) void fillOthers('spoken'); }} />
                <span className="settings-hint">Left blank, the AI reads the Name.</span></div>
            </div>
            {/* v12.10.28 (#2209): the per-system ids moved to Integrations › the system › Translations (Tushar 11/2 "each connected
                system will define translation there"). The rows are kept on the entry, untouched, and Translations edits them. */}
            <p className="settings-hint">The ID each connected system uses for this entry is set in <b>Integrations › the system › Translations</b>{systems.length > 0 ? <> (now: {systems.filter((r) => r.theirId).map((r) => `${r.system} ${r.theirId}`).join(' · ') || 'none'})</> : null}.</p>
            {!ed.isNew && <p className="settings-hint">Internal id <code>{ed.entry.id}</code> &mdash; it never changes, and a re-import matches on it.</p>}
          </Drawer>
        );
      })()}

      {/* v12.10.10 (#1407, UI-PROTO-T47-LIST-DRAWERS v1.0 #4): opening a drawer over unsaved page edits. */}
      {pendingOpen && (
        <div className="pz-modal-scrim" onMouseDown={(e) => { if (e.target === e.currentTarget) setPendingOpen(null); }}>
          <div className="pz-confirm" role="dialog" aria-modal="true" aria-label="Save your changes first?">
            <h4>Save your changes first?</h4>
            <p>You have {pageDirtyNames.length} unsaved {pageDirtyNames.length === 1 ? 'change' : 'changes'} on this page:</p>
            <ul>{pageDirtyNames.map((n) => <li key={n}>{n}</li>)}</ul>
            <p>Save them before opening the drawer, so your work is not mixed with the drawer.</p>
            <div className="pz-confirm-acts">
              <button type="button" className="pzc-btn" onClick={() => setPendingOpen(null)}>Cancel</button>
              <button type="button" className="pzc-btn" onClick={() => { const o = pendingOpen.open; setPendingOpen(null); discardPageThenOpen(o); }}>Discard them</button>
              <button type="button" className="pzc-btn pzc-pri" onClick={() => { const o = pendingOpen.open; setPendingOpen(null); void savePageThenOpen(o); }}>Save and open</button>
            </div>
          </div>
        </div>
      )}

      {/* v12.4.16 (#501): the loader on top of #500. */}
      {importFor && listsDraft?.[importFor] && (
        <ListImport
          list={listsDraft[importFor]}
          onClose={() => setImportFor(null)}
          onApply={(entries) => {
            if (listsDraft && listsDraft[importFor]) commitLists({ ...listsDraft, [importFor]: { ...listsDraft[importFor], entries } });   // v12.10.10 (#1407): saved at once
            setImportFor(null);
          }}
        />
      )}

      {removeList && (
        <ConfirmDelete
          what="list"
          name={removeList}
          consequence={(tiedFieldsOf(removeList).length
            ? `it is tied to ${tiedFieldsOf(removeList).map((t) => `{${t}}`).join(', ')} - removing it unties ${tiedFieldsOf(removeList).length === 1 ? 'that field' : 'those fields'}, and any prompt that offers it stops working. `
            : '') + 'Every entry in it goes with it, including entries that calls already taken point at. Deactivate individual entries instead if you only want to stop offering them.'}
          busy={removeListMut.isPending}
          onCancel={() => setRemoveList(null)}
          onConfirm={() => confirmRemoveList(removeList)}   /* v12.6.0 (#560) */
          confirmLabel="Remove"
        />
      )}

      {/* ── Add/edit drawer modals ───────────────────────────────────────── */}
      {ctModal && (
        <CallerTypeModal
          state={ctModal} list={draft.callerTypes} onClose={() => setCtModal(null)}
          onSave={(entry) => {
            // v12.10.10 (#1407): Save in the drawer writes at once.
            saveListNow((d) => { if (ctModal.index == null) d.callerTypes.push(entry); else d.callerTypes[ctModal.index] = entry; return d; }, (d) => saveCallerTypes.mutate(d));
            setCtModal(null);
          }} />
      )}
      {mcModal && (
        <CategoryModal
          state={mcModal} list={draft.categories} onClose={() => setMcModal(null)}
          onSave={(entry) => {
            saveListNow((d) => { if (mcModal.index == null) d.categories.push(entry); else d.categories[mcModal.index] = entry; return d; }, (d) => saveCategories.mutate(d));   // v12.10.10 (#1407)
            setMcModal(null);
          }} />
      )}
      {lbModal && (
        <LabelModal
          state={lbModal} list={draft.labels} onClose={() => setLbModal(null)}
          onSave={(entry) => {
            saveListNow((d) => { if (lbModal.index == null) d.labels.push(entry); else d.labels[lbModal.index] = entry; return d; }, (d) => saveLabels.mutate(d));   // v12.10.10 (#1407)
            setLbModal(null);
          }} />
      )}
    </div>
  );
}

// ── blanks ──
// v12.10.17 (#1723 D11): no Add for caller types / categories - the workflow owns the list, so ctBlank / mcBlank retired.
function lbBlank(): Label { return { name: '', description: '', color: PAL[6] }; }

// Alphabetical VIEW by name that preserves the true array index (for edit/delete by index).
function sortedView<T extends { name: string }>(list: T[]): { item: T; index: number }[] {
  return list.map((item, index) => ({ item, index })).sort((a, b) => a.item.name.localeCompare(b.item.name));
}

// ══ v12.10.26 (#2128, T148 / T154 Q7): NO FURTHER DETAILS. A completed message stays completed when a repeat call or a text reply
// says nothing, ends at "add anything else?" with a no, or says only one of these short replies (alone or together - "No, thank you").
// One box per language, one reply per line; an empty box = only "nothing said" counts in that language. Saved with Repeat callers. ══
const ND_LANGS: [string, string][] = [['en', 'English'], ['es', 'Spanish'], ['zh', 'Chinese']];
function NoDetailsRepliesEditor({ value, onChange }: { value: Record<string, string[]>; onChange: (v: Record<string, string[]>) => void }) {
  const [text, setText] = useState<Record<string, string>>({});
  const shown = (lang: string) => text[lang] ?? (value[lang] ?? []).join('\n');
  const commit = (lang: string, raw: string) => {
    const list = Array.from(new Set(raw.split(/\r?\n/).map((x) => x.trim()).filter((x) => x.length > 0))).slice(0, 40);
    onChange({ ...value, [lang]: list });
  };
  return (
    <div className="f">
      <label>No further details - these replies never reopen a completed message</label>
      <small className="settings-hint">A repeat call or a text reply that says nothing, ends at &ldquo;add anything else?&rdquo; with a no, or says only these
        (alone or together, e.g. &ldquo;No, thank you&rdquo;) keeps a completed message completed. Anything else reopens it. One reply per line.</small>
      <div className="nd-langs" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 12, marginTop: 8 }}>
        {ND_LANGS.map(([lang, name]) => (
          <div key={lang}>
            <small className="settings-hint"><b>{name}</b></small>
            <textarea rows={6} spellCheck={false} aria-label={`No further details - ${name}`} value={shown(lang)}
              onChange={(e) => { const v = e.target.value; setText((t) => ({ ...t, [lang]: v })); commit(lang, v); }}
              onBlur={() => setText((t) => { const n = { ...t }; delete n[lang]; return n; })} style={{ width: '100%' }} />
          </div>
        ))}
      </div>
    </div>
  );
}

// ── modal state type ──
interface ModalState<T> { index: number | null; draft: T }

// ── Section chrome (shared Settings section card) ──
// v12.10.18 (#1864): which saved keys each section owns.
const RC_KEYS = ['onCall', 'onCallWindow', 'classic', 'lines', 'routes', 'noDetailsReplies'] as const;   // v12.10.23 (#2068): + routes · v12.10.26 (#2128): + noDetailsReplies
const MW_KEYS = ['sameCaller', 'appendWindow', 'sameDay', 'refreshSeconds', 'autoComplete',
  'needsLive', 'needsVoicemail', 'needsSpokenWords', 'confirmRequiredAt'] as const;   // v12.10.19 (#1924 #1925)

// v12.10.18 (#1863, UI-PROTO-T148 v1.10 sections 1-2): the repeat-caller lines - standard language rail on top, one language at a
// time; an empty box speaks the Template default. The rows under each line say what the call does with each answer.
type RcLineKey = 'welcomeBack' | 'allCollected' | 'messageReceived';
// v12.10.19 (#1898): a repeat-caller line is spoken before Classify and before any card - only the practice's own tokens
// and the call's reference number can have a value there (the engine renders them with TokenResolver).
const RC_TOKEN_GROUPS = [
  { label: 'Practice', tokens: ['organization.practiceName', 'organization.phone', 'tenant.agentName', 'call.timeGreeting'] },
  ...platformGroups(),
];
const RC_TOKENS_KNOWN = [...RESOLVER_KNOWN_TOKENS, 'request.referenceNumber'];

const RC_LINE_DEFS: Record<RcLineKey, { title: string; sub: string; en: string; es: string }> = {
  welcomeBack: { title: 'Welcome back', sub: 'Something is still missing.',
    en: 'Welcome back. Shall we continue where we left off?', es: 'Bienvenido de nuevo. ¿Continuamos donde lo dejamos?' },
  allCollected: { title: 'Everything already collected', sub: 'Nothing is missing.',
    en: 'We have all your details. Would you like to add anything else?', es: 'Ya tenemos todos sus datos. ¿Desea agregar algo más?' },
  // v12.10.23 (#2068, S30 10/28): the Template default drops "Our staff will get back to you ..." - same text as PlatformPhrases repeat.messageReceived.
  messageReceived: { title: 'Message received', sub: 'The last call already left a message.',
    en: 'Hi, we received your call a few minutes ago. Would you like to add anything to your earlier call for our staff?',
    es: 'Hola, recibimos su llamada hace unos minutos. ¿Desea agregar algo a su llamada anterior para nuestro personal?' },
};
// v12.10.23 (#2068, UI-PROTO-T178 v1.4 LOCKED 10/28): Yes + details - the closing line said after the Addendum is saved (repeat.addendumSaved).
const RC_ADDENDUM_DEF = { title: 'Closing line · Yes + details', sub: 'Said after the caller’s details are saved as the Addendum; the call ends after it (no terminal card).',
  en: 'Thank you, I have added the details to your earlier call. Goodbye.', es: 'Gracias, agregué los detalles a su llamada anterior. Adiós.' };

// v12.10.23 (#2068): where each answer goes - one line per answer, the card name is a link that opens the picker. Stored in
// repeatCallers.routes (line -> answer -> destination); nothing saved = the defaults below (RepeatCallerSettings.DefaultRoute).
type RcAnswer = 'yes' | 'no' | 'new' | 'silent' | 'other';
const RC_DEST_LABEL: Record<string, string> = {
  continue: 'Continue the earlier request', greeting: 'Greeting', voicemail: 'Leave a Message', 'end-call': 'End call',
  handoff: 'Transfer to staff', thankyou: 'Thank You (Success)', 'thankyou-failure': 'Thank You (Failure)', fallback: 'Route to operator',
};
const RC_TERMINALS = ['voicemail', 'end-call', 'handoff', 'thankyou', 'thankyou-failure', 'fallback'];
const RC_ROUTE_ROWS: Record<RcLineKey, { answer: RcAnswer | 'details'; label: string; note?: string }[]> = {
  welcomeBack: [
    { answer: 'yes', label: 'Yes', note: 'asks only what is still missing' },
    { answer: 'no', label: 'No' },
    { answer: 'new', label: 'Something new', note: 'what was said is used as the request' },
    { answer: 'silent', label: 'Silent' }],
  allCollected: [
    { answer: 'yes', label: 'Yes', note: 'the card asks for the message (Take a message)' },
    { answer: 'details', label: 'Yes + details' },
    { answer: 'no', label: 'No' },
    { answer: 'silent', label: 'Silent' },
    { answer: 'other', label: 'Something else', note: 'not a clear yes / no' }],
  messageReceived: [
    { answer: 'yes', label: 'Yes', note: 'the card asks for the message (Take a message)' },
    { answer: 'details', label: 'Yes + details' },
    { answer: 'no', label: 'No' },
    { answer: 'silent', label: 'Silent' },
    { answer: 'other', label: 'Something else', note: 'not a clear yes / no' }],
};
const rcDefaultRoute = (line: RcLineKey, answer: RcAnswer): string => (line === 'welcomeBack'
  ? (answer === 'yes' ? 'continue' : answer === 'no' || answer === 'new' ? 'greeting' : 'end-call')
  : (answer === 'yes' || answer === 'other' ? 'voicemail' : 'end-call'));

/** v12.10.23 (#2068): the destination name as a link; a click opens a small list of the terminal cards (+ the two in-call places on Welcome back). */
function RcRoutePick({ line, value, onPick }: { line: RcLineKey; value: string; onPick: (dest: string) => void }) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLSpanElement | null>(null);
  useEffect(() => {
    if (!open) return;
    const close = (e: MouseEvent) => { if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false); };
    const esc = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', close);
    document.addEventListener('keydown', esc);
    return () => { document.removeEventListener('mousedown', close); document.removeEventListener('keydown', esc); };
  }, [open]);
  const choices = line === 'welcomeBack' ? ['continue', 'greeting', ...RC_TERMINALS] : RC_TERMINALS;
  return (
    <span className="rc-route" ref={ref}>
      <button type="button" className="rc-route-link" aria-haspopup="listbox" aria-expanded={open} onClick={() => setOpen((o) => !o)}>{RC_DEST_LABEL[value] ?? value}</button>
      {open && (
        <span className="rc-route-menu" role="listbox">
          <span className="rc-route-mh">{line === 'welcomeBack' ? 'In the call' : 'Route to'}</span>
          {choices.map((d) => (
            <button key={d} type="button" role="option" aria-selected={d === value} className={`rc-route-mi${d === value ? ' on' : ''}`}
              onClick={() => { onPick(d); setOpen(false); }}>{RC_DEST_LABEL[d]}</button>
          ))}
        </span>
      )}
    </span>
  );
}

function RepeatLinesEditor({ mode, lines, onChange, routes, onRoutes }: { mode: 'continue' | 'voicemail'; lines: Record<string, Record<string, string>>; onChange: (l: Record<string, Record<string, string>>) => void;
  routes: Record<string, Record<string, string>>; onRoutes: (r: Record<string, Record<string, string>>) => void }) {   // v12.10.23 (#2068): + routes
  const [lang, setLang] = useState<'en' | 'es'>('en');
  const keys: RcLineKey[] = mode === 'voicemail' ? ['messageReceived'] : ['welcomeBack', 'allCollected'];
  const setLine = (k: RcLineKey | 'addendumSaved', text: string) => onChange({ ...lines, [k]: { ...(lines[k] ?? {}), [lang]: text } });
  const routeOf = (k: RcLineKey, a: RcAnswer) => routes[k]?.[a] || rcDefaultRoute(k, a);
  const setRoute = (k: RcLineKey, a: RcAnswer, dest: string) => onRoutes({ ...routes, [k]: { ...(routes[k] ?? {}), [a]: dest } });
  const lineEditor = (k: RcLineKey | 'addendumSaved', def: { en: string; es: string }) => (
    /* v12.10.19 (#1898, LOCKED 10/23 S91): the SAME prompt editor as every spoken line - the template as real text with the
       Template default badge, Play, translate EN <-> ES, Reset, Insert token. Tokens: RC_TOKEN_GROUPS (spoken before Classify). */
    <PromptEditor value={lines[k]?.[lang] ?? ''} onChange={(v) => setLine(k, v)} language={lang} rows={2} platformDefault={lang === 'es' ? def.es : def.en}
      groups={RC_TOKEN_GROUPS} known={RC_TOKENS_KNOWN}
      translateSource={lines[k]?.[lang === 'en' ? 'es' : 'en'] ?? ''} translateSourceLang={lang === 'en' ? 'es' : 'en'}
      translateSourceDefault={lang === 'en' ? def.es : def.en} />
  );
  return (
    <div className="rc-lines">
      <div className="rq-lrail rc-lrail" role="tablist" aria-label="Language">
        {(['en', 'es'] as const).map((l) => (
          <button key={l} type="button" role="tab" aria-selected={lang === l} className={`rq-ltab${lang === l ? ' sel' : ''}`} onClick={() => setLang(l)}>{l === 'en' ? 'English · EN' : 'Spanish · ES'}</button>
        ))}
      </div>
      {keys.map((k) => {
        const def = RC_LINE_DEFS[k];
        return (
          <div key={k} className="rc-line">
            <h4 className="aa-subhead">{def.title}</h4>
            <p className="aa-sub-note">{def.sub}</p>
            {lineEditor(k, def)}
            {/* v12.10.23 (#2068): one line per answer - the card name is a link to the picker. */}
            {RC_ROUTE_ROWS[k].map((r) => {
              if (r.answer === 'details') return (
                <div key={r.answer} className="rc-line-row"><b>{r.label}</b><span>→ saved as the Addendum, then the closing line</span></div>
              );
              const a = r.answer;
              const dest = routeOf(k, a);
              return (
                <div key={a} className="rc-line-row"><b>{r.label}</b>
                  <span>→ <RcRoutePick line={k} value={dest} onPick={(d) => setRoute(k, a, d)} />
                    {r.note && dest === rcDefaultRoute(k, a) && <small className="rc-route-note">{r.note}</small>}</span>
                </div>
              );
            })}
          </div>
        );
      })}
      {/* v12.10.23 (#2068): the closing line after Yes + details (repeat.addendumSaved) - once, under the lines that offer it. */}
      <div className="rc-line">
        <h4 className="aa-subhead">{RC_ADDENDUM_DEF.title}</h4>
        <p className="aa-sub-note">{RC_ADDENDUM_DEF.sub}</p>
        {lineEditor('addendumSaved', RC_ADDENDUM_DEF)}
      </div>
    </div>
  );
}

function Section(props: {
  title: string; description: string; help?: HelpSection[];
  addLabel?: string; onAdd?: () => void;
  dirty: boolean; saving: boolean; onSave: () => void; onDiscard: () => void; children: ReactNode;
  noSave?: boolean;   // v12.10.10 (#1407): a section whose changes all save from drawers - no dead Discard / Save buttons
}) {
  return (
    <section className={`settings-section-card${props.dirty ? ' dirty' : ''}`}>
      <header className="settings-section-header">
        <div className="settings-section-headrow">
          <h2>{props.title}{props.help && <HelpTooltip sections={props.help} />}</h2>
          <div className="settings-actions">
            {props.addLabel && props.onAdd && (
              <button type="button" className="pz-add-btn" onClick={props.onAdd}><PlusIcon /> {props.addLabel}</button>
            )}
            {!props.noSave && <button type="button" className="settings-secondary" disabled={!props.dirty || props.saving} onClick={props.onDiscard}>Discard</button>}
            {!props.noSave && <button type="button" className="settings-primary" disabled={!props.dirty || props.saving} onClick={props.onSave}>{props.saving ? 'Saving…' : 'Save section'}</button>}
            {props.noSave && props.saving && <span className="settings-hint">Saving&hellip;</span>}
          </div>
        </div>
        <p className="pz-sec-desc">{props.description}</p>
      </header>
      <div className="pz-section-body">{props.children}</div>
    </section>
  );
}

function OverrideStrip({ label, on, onToggle }: { label: string; on: boolean; onToggle: () => void }) {
  return (
    <div className={`pz-override${on ? ' on' : ''}`}>
      <div className="pz-ov-txt">
        <span className="pz-ov-title">Allow agents to override the AI-assigned {label}</span>
        <span className="pz-ov-sub">{on ? `Agents can change a message's ${label} in the workspace.` : `The AI's ${label} is locked — agents can't change it in the workspace.`}</span>
      </div>
      <button type="button" className={`day-toggle${on ? '' : ' off'}`} onClick={onToggle} aria-label="Toggle override"><span className="knob" /></button>
    </div>
  );
}

// v12.10.17 (#1723 D2 D6): the system Unclassified row - plain person (caller) / question mark (category) on slate #64748B.
function LockedRow({ name, icon, iconKind, title, extraCells }: { name: string; icon: string; iconKind: 'caller' | 'category'; title: string; extraCells?: number }) {   // v12.10.22 (#2011): + extraCells (the Used by column)
  const Ico = iconKind === 'caller' ? CallerTypeIcon : PracticeIcon;
  return (
    <tr className="pz-locked" title={title}>
      <td data-label="Name"><span className="pz-name"><span className="pz-swatch" style={{ background: UNCLASSIFIED_SLATE }}><Ico name={icon} size={11} className="pz-swatch-ico" /></span>{name}</span></td>
      <td data-label="Color"><span className="pz-hex">{UNCLASSIFIED_SLATE}</span></td>
      <td data-label="Icon"><span className="pz-icon"><Ico name={icon} size={15} /> {iconKind === 'caller' ? 'Person (plain)' : 'Help'}</span></td>
      {Array.from({ length: extraCells ?? 0 }, (_, k) => <td key={k} />)}
      <td className="pz-acts" data-label=""><span className="pz-lock-badge"><LockIcon /> System</span></td>
    </tr>
  );
}

// ── Palette picker (the one new primitive) ──
function PalettePicker({ current, onChange, usedColors }: { current: string; onChange: (hex: string) => void; usedColors: string[] }) {
  const used = usedColors.map((c) => c.toLowerCase());
  const isUsed = (c: string) => used.includes(c.toLowerCase());
  const curUsed = isUsed(current);
  return (
    <>
      <div className="pz-palette">
        {PAL.map((c) => {
          const u = isUsed(c);
          const sel = c.toLowerCase() === current.toLowerCase();
          return (
            <button key={c} type="button" className={`pz-pal${sel ? ' sel' : ''}${u ? ' used' : ''}`} style={{ background: c }}
              onClick={() => onChange(c)} title={`${c}${u ? ' · already used in this list' : ''}`} aria-label={`${c}${u ? ' (already used)' : ''}`}>
              {u && <span className="pz-used-dot" />}
            </button>
          );
        })}
      </div>
      <div className={`pz-used-hint${curUsed ? ' show' : ''}`}><InfoIcon /> This color is already used by another entry in this list.</div>
      <div className="pz-custom">
        <span>Custom:</span>
        <span className="pz-custom-sw" style={{ background: current }} />
        <input className="pz-custom-hex" value={current} onChange={(e) => onChange(e.target.value)} />
      </div>
    </>
  );
}

// ── Drawer shell ──
function Drawer({ title, subtitle, saveLabel, canSave, onClose, onSave, children, danger }: {
  title: string; subtitle: string; saveLabel: string; canSave: boolean; onClose: () => void; onSave: () => void; children: ReactNode;
  danger?: { label: string; onClick: () => void };   // v12.10.10 (#1406): Remove list, bottom left
}) {
  useEffect(() => {
    function onKey(e: KeyboardEvent) { if (e.key === 'Escape') onClose(); }
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow; document.body.style.overflow = 'hidden';
    return () => { document.removeEventListener('keydown', onKey); document.body.style.overflow = prev; };
  }, [onClose]);
  return (
    <div className="pz-modal-scrim" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="pz-drawer" role="dialog" aria-modal="true" aria-label={title}>
        <div className="dw-accent" />
        <div className="dw-head">
          <div><h4>{title}</h4><p>{subtitle}</p></div>
          <button type="button" className="modal-x" onClick={onClose} aria-label="Close"><CloseIcon /></button>
        </div>
        <div className="dw-body">{children}</div>
        <div className="dw-foot">
          {danger && <button type="button" className="mc pz-danger" style={{ marginRight: 'auto' }} onClick={danger.onClick}>{danger.label}</button>}
          <button type="button" className="mc" onClick={onClose}>Cancel</button>
          <button type="button" className="ma" disabled={!canSave} onClick={onSave}>{saveLabel}</button>
        </div>
      </div>
    </div>
  );
}

// v12.10.17 (#1723 D11, BDR-018): the workflow owns the name, key and on/off - this drawer edits COLOUR + ICON only.
function CallerTypeModal({ state, list, onClose, onSave }: { state: ModalState<CallerType>; list: CallerType[]; onClose: () => void; onSave: (c: CallerType) => void }) {
  const [d, setD] = useState<CallerType>(state.draft);
  const used = list.filter((_, i) => i !== state.index).map((x) => x.color);
  return (
    <Drawer title="Edit Caller Type (Workflow)" subtitle="The name comes from your workflow. Pick the colour and icon of the caller's avatar tile in Messages."
      saveLabel="Save" canSave={!!d.color.trim()} onClose={onClose} onSave={() => onSave(d)}>
      <div className="f"><label>Name <span className="mrow-hint" style={{ marginLeft: 6 }}>— set in Settings › Workflow</span></label>
        <input value={d.name} readOnly disabled aria-readonly="true" /></div>
      <div className="f"><label>Color <span className="mrow-hint" style={{ marginLeft: 6 }}>— paints the caller's avatar tile in the workspace</span></label>
        <PalettePicker current={d.color} usedColors={used} onChange={(color) => setD((x) => ({ ...x, color }))} /></div>
      <div className="f"><label>Icon <span className="mrow-hint" style={{ marginLeft: 6 }}>— shown on the caller's avatar tile in the workspace</span></label>
        <div className="pz-icon-pick">
          <span className="pz-swatch pz-swatch-lg" style={{ background: d.color }}><CallerTypeIcon name={d.icon} size={18} className="pz-swatch-ico" /></span>
          <select value={d.icon} onChange={(e) => setD((x) => ({ ...x, icon: e.target.value }))}>
            {CALLER_ICON_GROUPS.map((g) => (
              <optgroup key={g.group} label={g.group}>{g.icons.map((ic) => <option key={ic} value={ic}>{iconLabel(ic)}</option>)}</optgroup>
            ))}
          </select>
        </div></div>
    </Drawer>
  );
}

function CategoryModal({ state, list, onClose, onSave }: { state: ModalState<Category>; list: Category[]; onClose: () => void; onSave: (c: Category) => void }) {
  const [d, setD] = useState<Category>(state.draft);
  const used = list.filter((_, i) => i !== state.index).map((x) => x.color);
  return (
    <Drawer title="Edit Category (Workflow)" subtitle="The name comes from your workflow's intent card. Pick the colour and icon of its pill in Messages."
      saveLabel="Save" canSave={!!d.color.trim()} onClose={onClose} onSave={() => onSave(d)}>
      <div className="f"><label>Name <span className="mrow-hint" style={{ marginLeft: 6 }}>— set on the workflow card</span></label>
        <input value={d.name} readOnly disabled aria-readonly="true" /></div>
      <div className="f"><label>Icon</label>
        <div className="pz-icon-pick">
          <span className="pz-swatch pz-swatch-lg" style={{ background: d.color }}><PracticeIcon name={d.icon} size={18} className="pz-swatch-ico" /></span>
          <select value={d.icon} onChange={(e) => setD((x) => ({ ...x, icon: e.target.value }))}>{CAT_ICONS.map((ic) => <option key={ic} value={ic}>{ic}</option>)}</select>
        </div></div>
      <div className="f"><label>Color</label>
        <PalettePicker current={d.color} usedColors={used} onChange={(color) => setD((x) => ({ ...x, color }))} /></div>
      <CategoryUsedBy categoryKey={state.draft.key} />
    </Drawer>
  );
}

// v12.10.11.1 (#1486, UI-PROTO-T56 v1.25 screen "files", LOCKED 10/9): which workflow intents file calls under this category -
// read-only; it is SET on the workflow intent card ("Files under"). Each row opens that card in Settings › Workflow.
// v12.10.17 (#1723 D10): the category IS the workflow's intent card - "Used by" lists the caller types whose workflow has it,
// each opening that card in Settings › Workflow (was: the intents filing under a Personalization category, #1486).
function CategoryUsedBy({ categoryKey }: { categoryKey: string }) {
  const wf = useQuery({
    queryKey: ['t2-workflow-modal-snapshot-raw'],
    queryFn: () => api.get<{ configJson?: string }>('/t2/workflow-modal'),
    staleTime: 30_000,
    retry: false,
  });
  const rows = useMemo(() => {
    if (!wf.data?.configJson || !categoryKey) return [];
    try {
      const doc = JSON.parse(wf.data.configJson) as { workflows?: { id?: string; name?: string; intents?: { id?: string; label?: string }[] }[] };
      const out: { workflowId: string; workflowName: string; intentId: string; intentLabel: string }[] = [];
      for (const w of doc.workflows ?? [])
        for (const i of w.intents ?? [])
          if ((i.id ?? '').toLowerCase() === categoryKey.toLowerCase())
            out.push({ workflowId: w.id ?? '', workflowName: w.name || w.id || 'Caller type', intentId: i.id ?? '', intentLabel: i.label || i.id || 'Intent' });
      return out;
    } catch { return []; }
  }, [wf.data, categoryKey]);
  return (
    <div className="f"><label>Used by <span style={{ fontWeight: 400, color: 'var(--soft, #94a3b8)' }}>- the caller types whose workflow has this card</span></label>
      {wf.isLoading ? <span className="mrow-hint">Loading…</span>
        : wf.isError ? <span className="mrow-hint">The workflow could not be read.</span>
        : rows.length === 0 ? <span className="mrow-hint">No caller type has this card in the workflow.</span>
        : (
          <div style={{ border: '1px solid var(--line, #e2e8f0)', borderRadius: 10, padding: '8px 10px', background: '#fafbfd' }}>
            {rows.map((r, i) => (
              <div key={`${r.workflowId}/${r.intentId}`} style={{ marginTop: i ? 4 : 0 }}>
                {r.workflowName} <span className="mrow-hint">· {r.intentLabel} card</span>&nbsp;
                <Link to={`/configuration/workflow?card=intent&wf=${encodeURIComponent(r.workflowId)}&intent=${encodeURIComponent(r.intentId)}`}>Open card →</Link>
              </div>
            ))}
          </div>
        )}
    </div>
  );
}

function LabelModal({ state, list, onClose, onSave }: { state: ModalState<Label>; list: Label[]; onClose: () => void; onSave: (l: Label) => void }) {
  const [d, setD] = useState<Label>(state.draft);
  const editing = state.index != null;
  const used = list.filter((_, i) => i !== state.index).map((x) => x.color);
  return (
    <Drawer title={editing ? 'Edit label' : 'Add label'} subtitle="A custom tag agents apply to organize messages in the workspace."
      saveLabel={editing ? 'Save' : 'Create'} canSave={!!d.name.trim()} onClose={onClose} onSave={() => { if (d.name.trim()) onSave(d); }}>
      <div className="f"><label>Name</label>
        <input value={d.name} placeholder="e.g. Follow-up Required" onChange={(e) => setD((x) => ({ ...x, name: e.target.value }))} /></div>
      <div className="f"><label>Description</label>
        <input value={d.description} placeholder="Optional description" onChange={(e) => setD((x) => ({ ...x, description: e.target.value }))} /></div>
      <div className="f"><label>Color</label>
        <PalettePicker current={d.color} usedColors={used} onChange={(color) => setD((x) => ({ ...x, color }))} /></div>
    </Drawer>
  );
}

// ── Number field (compact, matches the prototype numfield look via .f input) ──
// v12.10.17 (#1728): typing is free. The box no longer clamps on every keystroke (empty -> min, "6" -> 10, "60" -> "100"), so a
// value under the minimum's digit count can be typed. An in-range number goes to the draft as it is typed; an out-of-range or
// empty box keeps the last good value in the draft and, when the box loses focus, says the allowed range instead of jumping.
function NumberField({ value, onChange, unit, min, max }: { value: number; onChange: (v: number) => void; unit?: string; min: number; max: number }) {
  const [text, setText] = useState(String(value));
  const [bad, setBad] = useState(false);
  const inRange = (t: string) => t.trim() !== '' && Number.isFinite(Number(t)) && Number(t) >= min && Number(t) <= max;
  // v12.10.17 (#1728): a value changed from outside (Discard, a save, a load) shows in the box; our own typing already matches it.
  useEffect(() => { setText((t) => (inRange(t) && Number(t) === value ? t : String(value))); setBad(false); }, [value]);   // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
      <input type="text" inputMode="numeric" value={text} style={{ width: 130 }} aria-invalid={bad || undefined}
        className={bad ? 'pz-nf-bad' : undefined}
        onChange={(e) => { const t = e.target.value.replace(/[^0-9]/g, ''); setText(t); if (inRange(t)) { setBad(false); if (Number(t) !== value) onChange(Number(t)); } }}
        onBlur={() => setBad(!inRange(text))}
        onKeyDown={(e) => { if (e.key === 'Enter') setBad(!inRange(text)); }} />
      {unit && <span className="mrow-hint">{unit}</span>}
      {bad && <small className="pz-nf-range" role="alert">Allowed: {min}&ndash;{max}{unit ? ` ${unit}` : ''}</small>}
    </div>
  );
}

// ── help copy (ported from the prototype helpTip() calls) ──
const CT_HELP: HelpSection[] = [
  ['What it does', 'The caller types of your workflow (e.g. Patient, Pharmacy, Referring physician) - names come from Settings › Workflow. Here you pick each type\'s colour and icon.'],
  ['When it fires', 'The AI classifies each caller into one of these types during the call. The color then paints that caller’s avatar tile in the agent workspace, so staff can tell at a glance who a message is from.'],
  ['Example', 'A call from a pharmacy is typed Pharmacy → its teal color fills the avatar tile on that message card. If the AI can’t classify the caller, it shows as Unclassified (a neutral “?” tile).'],
];
const CAT_HELP: HelpSection[] = [
  ['What it does', 'The intent cards of your workflow (e.g. Appointment, Prescription) - names come from the workflow cards. Here you pick each card\'s colour and icon.'],
  ['When it fires', 'The AI assigns one category to each incoming message. It appears as the colored category chip on that message’s card in the workspace and as a filter agents can sort by.'],
  ['Example', 'A caller asking to refill a prescription is categorized Rx Refill → that chip shows on the card and can be filtered. If the request could not be told, it shows as Unclassified.'],
];
const LB_HELP: HelpSection[] = [
  ['What it does', 'Defines the custom tags agents can apply to messages themselves (e.g. Callback Done, Follow-up Required, VIP Patient). Unlike caller types and categories, labels are applied by people, not the AI.'],
  ['When it fires', 'An agent adds a label to a message in the workspace when they want to — labels are optional. They appear as tag chips on the message card.'],
  ['Example', 'After returning a call, an agent tags the message Callback Done; a supervisor filters by Follow-up Required to see outstanding work.'],
];
// v12.10.16 (T113): Repeat callers / Automatic status help.
const RC_ONCALL_HELP: HelpSection[] = [
  ['What it does', 'What the CALL does when the same number calls again within these minutes (counted from the previous call\u2019s start).'],
  ['Continue where left off', 'No recording notice or ID check again; what the last call collected is carried forward and the AI asks only what is still missing ("Welcome back. Shall we continue where we left off?").'],
  ['Straight to voicemail', 'A caller whose last call left a message hears "we received your message ... anything else you\u2019d like to add?" - what they add is saved as the Addendum. No message yet = the voicemail greeting.'],
  ['Mode \u00b7 Classic', 'On = exactly as before 12.10.18 (Skip the opening / the voicemail greeting), no new lines. Off by default.'],
  ['Withheld numbers', 'A caller with no number (withheld / anonymous) is never treated as a repeat caller.'],
];
// v12.10.18 (#1864): the Messages workspace section's own help.
const MW_HELP: HelpSection[] = [
  ['What it does', 'How the calls of one caller show in Messages, how often the list refreshes, and the statuses the system sets for you.'],
  ['Each call stays its own record', 'Grouping is how Messages SHOWS them. Mark complete closes every open call in the group; a new call takes the assignee and labels; notes stay on their own call.'],
];
const AS_HELP: HelpSection[] = [
  ['What it does', 'Statuses the system sets on a message without anyone opening it. The message\u2019s Activity says the system did it.'],
  ['Missed calls with no details', 'The caller said nothing, left no voicemail and nothing was captured. Marked Completed when the call ends.'],
];
const GR_HELP: HelpSection[] = [
  ['What it does', 'On the call: what happens when the same number calls again within a few minutes. In the messages: whether the calls of one caller show as ONE card (\u00d7N times) with every call Combined in the drawer, or each as its own card.'],
  ['Each call stays its own record', 'Grouping is how Messages SHOWS them. Mark complete closes every open call in the group; a new call takes the assignee and labels; notes stay on their own call; the one reminder sits on the latest call.'],
  ['Example', 'A patient calls three times in 20 minutes. Grouped, Messages shows one card \u201c\u00d73 times\u201d with the other calls\u2019 numbers; the drawer reads all three together.'],
];
const GR_MODE_HELP: HelpSection[] = [
  ['What it does', 'Whether a repeat call from the same caller continues their previous conversation or opens a new one in the agent workspace.'],
  ['When it fires', 'At call start, after the caller is identified by number.'],
  ['Example', 'Continue previous conversation = the callback appends to the earlier message thread so it reads as one conversation. Start a new conversation = every call is its own separate message.'],
];
const GR_WINDOW_HELP: HelpSection[] = [
  ['What it does', 'How long after a caller\u2019s latest call a new call still joins the group - in minutes, or the whole day with Same day.'],
  ['When it fires', 'Only when In the messages is set to Group with the previous calls.'],
  ['Example', '120 minutes: a call at 2:18 PM joins a 2:00 PM call; a call at 4:30 PM starts a new card.'],
];
const VOCAB_HELP: HelpSection[] = [
  ['What it does', 'Rename the standard call roles to your own words (for example subject to "Patient", provider to "Doctor"). Only the label changes; the field underneath stays the same, so your workflows keep working.'],
  ['When it fires', 'Everywhere the entity is shown or spoken: the workflow token picker, the AI’s spoken read-backs during a call, and call summaries all use your label.'],
  ['Example', 'Rename subject to “Patient” and the token picker shows “Patient › Date of birth” while it still stores {subject.dob}; the AI says “And the Patient’s date of birth?” instead of “the subject’s”.'],
  // v12.4.16 (#499): renaming is no longer the ONLY thing you can do here, so the help says what the new
  // button does and - just as important - what it deliberately will not do.
  ['Adding your own fields', 'Use + Add field on any row to hang a field of your own off it — an account number on “Who called”, say. It becomes {entity.field} and is offered everywhere a built-in field is: workflow cards, integration mappings, identity extraction. Built-in fields can be relabelled but never renamed away or deleted, and a key you already use is refused rather than quietly merged.'],
];

// ── inline icons ──
// v12.4.16 (#499): the tenant's OWN fields on one entity, and the button that adds another.
//
// It renders on a PLATFORM row and on a tenant's own entity row, from one definition, because the difference
// between those two cases is only which entity it was handed - which is exactly the point of #499. A platform
// row's built-in fields are printed above it as a read-only line and are not listed here: they cannot be
// renamed away or deleted (BDR-001 v1.2 section 7.6), so offering Edit/Remove on them would promise something
// the API refuses.
function TenantFields({ entity, fields, onAdd, onEdit, onRemove, asChips = false }: {
  entity: string;
  fields: Array<{ key: string; field: string; label: string; type: string; source: string; listKey: string; isOn?: boolean }>;
  onAdd: () => void;
  onEdit: (f: { key: string; field: string; label: string; type: string; source: string; listKey: string }) => void;
  onRemove: (f: { key: string; field: string; label: string; type: string; source: string; listKey: string }) => void;
  /** v12.7.2 (#614): render as the same dot-separated chip line the platform rows use. */
  asChips?: boolean;
}) {
  // v12.7.2 (#614): the SAME classes the platform rows use - vocab-fields / vocab-field-chip - so the two
  // halves of this table cannot drift again. Nothing new is styled; a chip here opens the drawer in EDIT
  // mode, where a platform chip opens it read-only (#576), because a tenant's own field is theirs to change.
  if (asChips) {
    return (
      <div className="vocab-own">
        {fields.length > 0 && (
          <small className="vocab-fields cust"><span className="vocab-cap">Custom:</span>{' '}
            {fields.map((f) => (
              <button key={f.key} type="button" className={`vocab-field-chip${f.isOn === false ? ' is-off' : ''}`}
                      title={`${entity}.${f.field}${f.type ? ` \u00b7 ${f.type}` : ''}${f.isOn === false ? ' \u00b7 Off - hidden from screens' : ''} \u2014 click to edit`}
                      onClick={() => onEdit(f)}>
                {f.field}
              </button>
            ))}
          </small>
        )}
        <button type="button" className="vocab-addfield" onClick={onAdd}>+ Add field</button>
      </div>
    );
  }
  return (
    <div className="vocab-own">
      {fields.length > 0 && (
        <ul className="vocab-own-list">
          {fields.map((f) => (
            <li key={f.key} className={`vocab-own-item${f.isOn === false ? ' is-off' : ''}`}>
              <code className="pz-key">{`${entity}.${f.field}`}</code>
              <span className="vocab-own-label">{f.label}</span>
              <span className="vocab-own-type">{f.type}</span>
              <button type="button" className="icon-btn" aria-label={`Edit ${f.field}`} title="Edit" onClick={() => onEdit(f)}><EditIcon /></button>
              <button type="button" className="icon-btn danger" aria-label={`Remove ${f.field}`} title="Remove" onClick={() => onRemove(f)}><TrashIcon /></button>
            </li>
          ))}
        </ul>
      )}
      <button type="button" className="vocab-addfield" onClick={onAdd}>+ Add field</button>
    </div>
  );
}


/* ══ v12.4.16 (#500 / #501): Lists ═════════════════════════════════════════════════════════════════════ */

const LISTS_HELP: HelpSection[] = [
  ['What it does', 'Holds the legal values a field can take — your providers, your locations, the kinds of visit you offer — with what each one is called on screen, what a caller might call it, what the AI should say back, and the id each connected system knows it by.'],
  ['Why the ids are per system', 'The same provider is 1234 in one system and DR-88 in the next. One shared "external id" column works until the second system arrives, and then fails quietly.'],
  ['Deactivate, never delete', 'Calls already taken point at these rows. Deactivating stops an entry being offered and leaves every call that used it resolving.'],
  ['On a live call (12.10.10)', 'Tie a field to a list in Vocabulary › Fields. The AI matches what the caller says (Name, Caller might say, AI says back, every language); two close entries -> it asks which; no match -> it keeps what was heard. {lists.entity.field} in a prompt offers the Active entries, top N (Offer up to). At send time each connected system gets its own value and id.'],
];

// ── v12.10.10 (#1406): the entry drawer's working state ─────────────────────────────────────────────────
// aliasText holds the RAW "Caller might say" text per language (#558: split only on commit); auto marks a box the
// machine filled (C10 - shown "auto-translated · edit to correct" until a person types in it).
interface EntryDraftState { list: string; entry: ListEntry; isNew: boolean; aliasText: Record<string, string>; lang: string; auto: Record<string, boolean> }
function entryDraftFor(list: string, en: ListEntry, isNew: boolean, langs: string[]): EntryDraftState {
  const primary = langs[0] ?? 'en';
  const aliasText: Record<string, string> = { [primary]: en.aliases.join(', ') };
  for (const [l, a] of Object.entries(en.aliasesByLang ?? {})) if (l !== primary) aliasText[l] = (a ?? []).join(', ');
  const systems: EntrySystem[] = en.systems ?? Object.entries(en.externalIds ?? {}).map(([system, theirId]) => ({ system, valueFrom: 'typed' as const, value: '', theirId }));
  return { list, entry: { ...structuredClone(en), systems }, isNew, aliasText, lang: primary, auto: {} };
}
function entryFromDraft(d: EntryDraftState, primary: string): ListEntry {
  const aliasesByLang: Record<string, string[]> = {};
  for (const [l, t] of Object.entries(d.aliasText)) if (l !== primary) { const a = splitAliases(t ?? ''); if (a.length) aliasesByLang[l] = a; }
  const systems = (d.entry.systems ?? []).filter((r) => r.system.trim());
  const externalIds: Record<string, string> = {};
  for (const r of systems) if (r.theirId.trim()) externalIds[r.system.trim()] = r.theirId.trim();
  const spokenByLang: Record<string, string> = {};
  for (const [l, v] of Object.entries(d.entry.spokenByLang ?? {})) if (l !== primary && (v ?? '').trim()) spokenByLang[l] = v.trim();
  return { ...d.entry, name: d.entry.name.trim(), aliases: splitAliases(d.aliasText[primary] ?? ''), aliasesByLang, spokenByLang, systems, externalIds };
}
/** v12.10.10 (#1406): a new list's permanent internal id - fields tie to it, so the name can change freely. */
function newListId(taken: string[]): string {
  for (;;) { const id = 'lst_' + Math.random().toString(36).slice(2, 10); if (!taken.includes(id)) return id; }
}
function langWord(code: string): string {
  const m: Record<string, string> = { en: 'English', es: 'Spanish', fr: 'French', de: 'German', pt: 'Portuguese', it: 'Italian', zh: 'Chinese', vi: 'Vietnamese', ko: 'Korean', ru: 'Russian', ar: 'Arabic', hi: 'Hindi', gu: 'Gujarati', tl: 'Tagalog', pl: 'Polish', ht: 'Haitian Creole' };
  return m[code] ?? code.toUpperCase();
}

function blankEntry(): ListEntry {
  // A client-side id so a row added and edited before Save keeps its identity. The server regenerates any id
  // it does not like, and preserves one it does - CleanLists in OrganizationSettingsController.
  const rnd = Math.random().toString(36).slice(2, 8) + Date.now().toString(36).slice(-6);
  return { id: rnd.slice(0, 12), name: '', description: '', aliases: [], spoken: '', active: true, externalIds: {} };
}

// ── v12.6.1 (#561): A LIST'S KEY COMES FROM ITS NAME. ───────────────────────────────────────────────
//
// It used to be handed out by a counter that never looked at the name:
//
//     let key = 'new_list'; let n = 2;
//     while (listsDraft[key]) { key = `new_list_${n}`; n += 1; }
//
// So harlemm's **Providers** list is keyed `new_list` and **Locations** is `new_list_2`. Two consequences,
// and the second is the dangerous one:
//
//   1. Configuration becomes unreadable. A vocabulary field carries `listKey`, so its definition says it draws
//      its legal values from `new_list` - which tells the next person debugging an integration nothing.
//   2. **KEYS WERE RECYCLED.** The loop takes the lowest free slot, so deleting Providers (`new_list`) and
//      then creating any new list hands `new_list` straight to it - and a field still bound to `new_list`
//      silently starts drawing its values from a completely different list. Nothing warns; the binding still
//      resolves. That is the hazard, and NAME-DERIVATION ALONE REMOVES IT: a list called Locations can never
//      be handed the key `providers`.
//
// Matches `OrganizationSettingsController.NormalizeListKey` character for character, because the API
// normalises the key on every write and a T2 that disagreed would rename a list on save.
function slugifyListKey(name: string): string {
  const k = (name ?? '').trim().toLowerCase();
  let out = '';
  for (const c of k) {
    if (/[a-z0-9]/.test(c)) out += c;
    else if (out.length > 0 && out[out.length - 1] !== '_') out += '_';
  }
  return out.replace(/^_+|_+$/g, '');
}

// A name can collide - two lists really can both be called "Providers". The suffix is a last resort, not the
// scheme, which is the whole difference from the counter this replaces.
function uniqueListKey(base: string, taken: Iterable<string>): string {
  const used = new Set([...taken].map((k) => k.toLowerCase()));
  const root = base || 'list';
  if (!used.has(root)) return root;
  let n = 2;
  while (used.has(`${root}_${n}`)) n += 1;
  return `${root}_${n}`;
}

// Re-keying is only ever safe BEFORE a list reaches the server: once saved, a field may be bound to the key
// and renaming the list must not move that binding. `listsSaved` IS the server's copy, so its absence there is
// the test - the same one #560 uses.
function reKeyList(m: Record<string, RefList> | null, oldKey: string, newKey: string): Record<string, RefList> | null {
  if (!m || oldKey === newKey || !m[oldKey] || m[newKey]) return m;
  const next: Record<string, RefList> = {};
  for (const [k, v] of Object.entries(m)) {
    if (k === oldKey) next[newKey] = { ...v, key: newKey };
    else next[k] = v;
  }
  return next;
}

// v12.6.0 (#560): drop one list from a map, without mutating it. Returns the map unchanged when the key
// is not there, so a caller never has to check twice.
function dropList(m: Record<string, RefList> | null, key: string): Record<string, RefList> | null {
  if (!m || !(key in m)) return m;
  const next = { ...m };
  delete next[key];
  return next;
}

function splitAliases(v: string): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const raw of (v ?? '').split(',')) {
    const a = raw.trim();
    if (!a) continue;
    const k = a.toLowerCase();
    if (seen.has(k)) continue;
    seen.add(k); out.push(a);
  }
  return out;
}

function patchList(m: Record<string, RefList> | null, key: string, patch: Partial<RefList>): Record<string, RefList> | null {
  if (!m || !m[key]) return m;
  return { ...m, [key]: { ...m[key], ...patch } };
}

function patchEntry(m: Record<string, RefList> | null, key: string, id: string, patch: Partial<ListEntry>): Record<string, RefList> | null {
  if (!m || !m[key]) return m;
  return { ...m, [key]: { ...m[key], entries: m[key].entries.map((e) => (e.id === id ? { ...e, ...patch } : e)) } };
}

// v12.4.16 (#500): the external-id map, as rows. A map does not fit in a table cell without pretending it is
// one value, which is the single-externalId trap in a different coat.
function ExternalIdRows({ value, onChange }: { value: Record<string, string>; onChange: (v: Record<string, string>) => void }) {
  const rows = Object.entries(value);
  const set = (i: number, k: string, v: string) => {
    const next: Record<string, string> = {};
    rows.forEach(([ok, ov], j) => { const kk = j === i ? k : ok; const vv = j === i ? v : ov; if (kk.trim()) next[kk.trim()] = vv; });
    onChange(next);
  };
  return (
    <div className="lst-extids">
      {rows.map(([k, v], i) => (
        <div key={i} className="lst-extid-row">
          <input className="lst-extid-sys" value={k} placeholder="system, e.g. pmweb" onChange={(e) => set(i, e.target.value, v)} />
          <span className="ca-map-arrow" aria-hidden="true">&rarr;</span>
          <input className="lst-extid-val" value={v} placeholder="their id, e.g. 1234" onChange={(e) => set(i, k, e.target.value)} />
          <button type="button" className="icon-btn danger" aria-label="Remove" onClick={() => {
            const next: Record<string, string> = {};
            rows.forEach(([ok, ov], j) => { if (j !== i && ok.trim()) next[ok] = ov; });
            onChange(next);
          }}><TrashIcon /></button>
        </div>
      ))}
      <button type="button" className="vocab-addfield" onClick={() => onChange({ ...value, '': '' })}>+ Add a system</button>
    </div>
  );
}

// ── v12.4.16 (#501): bulk import ────────────────────────────────────────────────────────────────────────
//
// THE HARD PART IS NOT PARSING, IT IS THE SECOND IMPORT. A practice adds two providers and re-uploads the same
// sheet: the system must UPDATE rather than duplicate, and must not delete the provider that 1,400 historical
// calls point at. So: match by internal id where the file carries one, otherwise by name (case-insensitively),
// and NEVER remove an entry that is merely absent from the file - a row missing from a sheet is far more often
// a partial export than an instruction to delete.
//
// FORMATS: CSV, TSV and JSON, plus whatever the tenant pastes. **.xlsx is NOT parsed** - it is a zip container
// and reading it needs a dependency this app does not carry. The panel says so and asks for Save as CSV, which
// is one menu item in Excel, rather than shipping a file picker that accepts .xlsx and then fails on it.
function parseDelimited(text: string): Record<string, string>[] {
  const lines = text.replace(/\r\n?/g, '\n').split('\n').filter((l) => l.trim().length > 0);
  if (lines.length < 2) return [];
  const delim = (lines[0].match(/\t/g)?.length ?? 0) > (lines[0].match(/,/g)?.length ?? 0) ? '\t' : ',';
  // A minimal RFC4180 reader: quoted fields may contain the delimiter and doubled quotes.
  const cut = (line: string): string[] => {
    const out: string[] = []; let cur = ''; let q = false;
    for (let i = 0; i < line.length; i += 1) {
      const c = line[i];
      if (q) {
        if (c === '"') { if (line[i + 1] === '"') { cur += '"'; i += 1; } else q = false; }
        else cur += c;
      } else if (c === '"') q = true;
      else if (c === delim) { out.push(cur); cur = ''; }
      else cur += c;
    }
    out.push(cur);
    return out.map((x) => x.trim());
  };
  const head = cut(lines[0]);
  return lines.slice(1).map((l) => {
    const cells = cut(l);
    const row: Record<string, string> = {};
    head.forEach((h, i) => { if (h) row[h] = cells[i] ?? ''; });
    return row;
  });
}

function parseImport(text: string): { rows: Record<string, string>[]; columns: string[]; error?: string } {
  const t = (text ?? '').trim();
  if (!t) return { rows: [], columns: [] };
  if (t.startsWith('[') || t.startsWith('{')) {
    try {
      const j = JSON.parse(t);
      const arr: unknown[] = Array.isArray(j) ? j : (Array.isArray((j as { data?: unknown[] }).data) ? (j as { data: unknown[] }).data : [j]);
      const rows = arr.filter((x) => x && typeof x === 'object').map((x) => {
        const row: Record<string, string> = {};
        for (const [k, v] of Object.entries(x as Record<string, unknown>))
          row[k] = v === null || v === undefined ? '' : (typeof v === 'object' ? JSON.stringify(v) : String(v));
        return row;
      });
      const columns = Array.from(new Set(rows.flatMap((r) => Object.keys(r))));
      return { rows, columns };
    } catch { return { rows: [], columns: [], error: 'That is not valid JSON yet.' }; }
  }
  const rows = parseDelimited(t);
  if (rows.length === 0) return { rows: [], columns: [], error: 'Needs a header row and at least one row of data.' };
  return { rows, columns: Array.from(new Set(rows.flatMap((r) => Object.keys(r)))) };
}

// The fields a file column can be mapped onto. `externalId` takes a system name alongside it, because an id
// means nothing without saying whose id it is.
const IMPORT_TARGETS: [string, string][] = [
  ['', 'Ignore this column'],
  ['id', 'Internal id (matches an existing entry)'],
  ['name', 'Name'],
  ['description', 'Description'],
  ['aliases', 'Caller might say (comma-separated)'],
  ['spoken', 'AI says back'],
  ['active', 'Active (true / false, yes / no, 1 / 0)'],
  ['externalId', 'Their id, for the system named below'],
];

function ListImport({ list, onClose, onApply }: { list: RefList; onClose: () => void; onApply: (entries: ListEntry[]) => void }) {
  const [text, setText] = useState('');
  const [map, setMap] = useState<Record<string, string>>({});
  const [systems, setSystems] = useState<Record<string, string>>({});   // column -> which system its id belongs to

  const parsed = useMemo(() => parseImport(text), [text]);

  // Guess the mapping from the header names, because a tenant exporting from their own system gets columns
  // called "Name" and "ProviderId" and should not have to point at every one of them by hand.
  useEffect(() => {
    if (parsed.columns.length === 0) return;
    const guess: Record<string, string> = {};
    for (const c of parsed.columns) {
      const k = c.toLowerCase().replace(/[^a-z]/g, '');
      if (k === 'id' || k === 'internalid') guess[c] = 'id';
      else if (k === 'name' || k === 'displayname' || k === 'fullname') guess[c] = 'name';
      else if (k === 'description' || k === 'notes') guess[c] = 'description';
      else if (k.includes('alias') || k.includes('synonym')) guess[c] = 'aliases';
      else if (k.includes('spoken') || k.includes('saysback')) guess[c] = 'spoken';
      else if (k === 'active' || k === 'enabled' || k === 'isactive') guess[c] = 'active';
      else if (k.includes('externalid') || k.endsWith('id')) guess[c] = 'externalId';
    }
    setMap(guess);
  }, [parsed.columns.join('\u0001')]);   // eslint-disable-line react-hooks/exhaustive-deps

  // THE PREVIEW IS THE FEATURE. It says exactly what pressing Merge will do, per row, BEFORE it happens -
  // the acceptance criterion's "the rows that would be added and the rows that would be skipped".
  const plan = useMemo(() => {
    const colFor = (target: string) => parsed.columns.find((c) => map[c] === target);
    const nameCol = colFor('name');
    const idCol = colFor('id');
    const descCol = colFor('description');
    const aliasCol = colFor('aliases');
    const spokenCol = colFor('spoken');
    const activeCol = colFor('active');
    const extCols = parsed.columns.filter((c) => map[c] === 'externalId');

    const byId = new Map(list.entries.map((e) => [e.id.toLowerCase(), e]));
    const byName = new Map(list.entries.map((e) => [e.name.trim().toLowerCase(), e]));
    const next = list.entries.map((e) => structuredClone(e));
    const idx = new Map(next.map((e, i) => [e.id, i]));
    let added = 0, updated = 0;
    const skipped: string[] = [];

    if (!nameCol) return { next, added: 0, updated: 0, skipped, ready: false, reason: 'Point one column at Name — an entry with no name is not an entry.' };

    for (const row of parsed.rows) {
      const name = (row[nameCol] ?? '').trim();
      if (!name) { skipped.push('a row with no name'); continue; }
      const fileId = idCol ? (row[idCol] ?? '').trim() : '';
      const existing = (fileId && byId.get(fileId.toLowerCase())) || byName.get(name.toLowerCase());
      const target = existing ? next[idx.get(existing.id)!] : blankEntry();
      target.name = name;
      if (descCol) target.description = (row[descCol] ?? '').trim();
      if (aliasCol) target.aliases = splitAliases(row[aliasCol] ?? '');
      if (spokenCol) target.spoken = (row[spokenCol] ?? '').trim();
      if (activeCol) {
        const v = (row[activeCol] ?? '').trim().toLowerCase();
        if (v) target.active = v === 'true' || v === 'yes' || v === 'y' || v === '1' || v === 'active';
      }
      for (const c of extCols) {
        const sys = (systems[c] ?? '').trim();
        const val = (row[c] ?? '').trim();
        if (sys && val) target.externalIds = { ...target.externalIds, [sys]: val };
      }
      if (existing) updated += 1;
      else { next.push(target); idx.set(target.id, next.length - 1); added += 1; }
    }
    const missingSystem = extCols.some((c) => !(systems[c] ?? '').trim());
    return {
      next, added, updated, skipped, ready: !missingSystem,
      reason: missingSystem ? 'Name the system each "their id" column belongs to — an id means nothing without it.' : undefined,
    };
  }, [parsed, map, systems, list]);

  return (
    <Drawer
      title={`Import into ${list.name}`}
      subtitle="Paste or open a CSV, TSV or JSON file, point its columns at these fields, and see what will change before anything does."
      saveLabel={`Merge ${plan.added + plan.updated} row${plan.added + plan.updated === 1 ? '' : 's'}`}
      canSave={plan.ready && plan.added + plan.updated > 0}
      onClose={onClose}
      onSave={() => onApply(plan.next)}>

      <div className="f">
        <label>File</label>
        <input type="file" accept=".csv,.tsv,.txt,.json" onChange={(e) => {
          const f = e.target.files?.[0];
          if (!f) return;
          if (/\.xlsx?$/i.test(f.name)) { toast('error', 'Excel files are not read here', 'Open it in Excel and choose Save as → CSV, then try again.'); return; }
          const r = new FileReader();
          r.onload = () => setText(String(r.result ?? ''));
          r.readAsText(f);
        }} />
        <span className="settings-hint">CSV, TSV or JSON. An <b>.xlsx</b> is a zip container and is not read here &mdash; open it in Excel and choose Save as &rarr; CSV. Nothing is uploaded: the file is read in your browser.</span>
      </div>

      <div className="f">
        <label>…or paste the rows</label>
        <textarea rows={6} spellCheck={false} value={text} onChange={(e) => setText(e.target.value)}
          placeholder={'Name,Description,Aliases,PmwebId\nGonzales, Jessica Jr,Pediatrics,"Doctor Jessica, Dr Gonzales",1234'} />
        {parsed.error ? <span className="settings-hint lst-warn">&#9888; {parsed.error}</span>
          : parsed.rows.length > 0 ? <span className="settings-hint">{parsed.rows.length} row{parsed.rows.length === 1 ? '' : 's'}, {parsed.columns.length} column{parsed.columns.length === 1 ? '' : 's'}.</span> : null}
      </div>

      {parsed.columns.length > 0 && (
        <div className="f">
          <label>Which column is which</label>
          {parsed.columns.map((c) => (
            <div key={c} className="lst-extid-row">
              <code className="pz-key lst-extid-sys">{c}</code>
              <span className="ca-map-arrow" aria-hidden="true">&rarr;</span>
              <select className="lst-extid-val" value={map[c] ?? ''} onChange={(e) => setMap((m) => ({ ...m, [c]: e.target.value }))}>
                {IMPORT_TARGETS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
              </select>
              {map[c] === 'externalId' && (
                <input className="lst-extid-val" value={systems[c] ?? ''} placeholder="which system? e.g. pmweb"
                  onChange={(e) => setSystems((m) => ({ ...m, [c]: e.target.value }))} />
              )}
            </div>
          ))}
        </div>
      )}

      {parsed.rows.length > 0 && (
        <div className="lst-plan">
          {plan.reason ? <p className="lst-warn">&#9888; {plan.reason}</p> : (
            <>
              <p><b>{plan.added}</b> new {plan.added === 1 ? 'entry' : 'entries'} · <b>{plan.updated}</b> existing updated{plan.skipped.length ? ` · ${plan.skipped.length} skipped` : ''}.</p>
              <p className="settings-hint">Matched by internal id where the file has one, otherwise by name. An entry already in this list but <em>absent</em> from the file is left exactly as it is &mdash; never removed, because calls already taken point at it.</p>
              <p className="settings-hint">Nothing is stored until you press Save on the Lists section.</p>
            </>
          )}
        </div>
      )}
    </Drawer>
  );
}

function PlusIcon() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><path d="M12 5v14M5 12h14" /></svg>; }
function EditIcon() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.1 2.1 0 0 1 3 3L12 15l-4 1 1-4z" /></svg>; }
function TrashIcon() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" /></svg>; }
function CloseIcon() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><path d="M18 6L6 18M6 6l12 12" /></svg>; }
function LockIcon() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>; }
function HelpDot() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><path d="M9.1 9a3 3 0 0 1 5.8 1c0 2-3 3-3 3M12 17h.01" /></svg>; }
function InfoIcon() { return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><path d="M12 8v4M12 16h.01" /></svg>; }

/* ══ v12.10.8.1 (#1229, prototype v1.6): the TERM is a locked box the size of Your label, so the two columns line up. ══
   Pointing at it or clicking it shows a not-allowed cursor and why. */
const TERM_LOCKED_HINT = "The term can't be changed - your workflows and integrations store data under it. Change Your label instead.";
function TermBox({ token }: { token: string }) {
  return <span className="vocab-term" tabIndex={0} title={TERM_LOCKED_HINT} data-hint={TERM_LOCKED_HINT}>{token}</span>;
}

function cap(t: string) { return t ? t.charAt(0).toUpperCase() + t.slice(1) : t; }
